module.exports = {
  lang: 'English',
  // router, 路由
  router: {
    title: 'XIOT',
    home: {
      title: 'XIOT',
      name: 'XIOT',
      desc: ''
    },
    case: {
      title: 'XIOT-Solution',
      name: 'Solution',
      desc: ''
    },
    paddy: {
      title: 'XIOT-Rice Irrigation Solution',
      name: 'Rice Irrigation Solution',
      desc: 'Realizie rational irrigation of rice'
    },
    cotton: {
      title: 'XIOT-Cotton Field Irrigation Solution',
      name: 'Cotton Field Irrigation Solution',
      desc: 'Intelligent irrigation of cotton field'
    },
    trace: {
      title: 'XIOT-Product Traceability Solution',
      name: 'Product Traceability Solution',
      desc: 'Provide product traceability for agricultural products'
    },
    products: {
      title: 'XIOT-Product',
      name: 'Product',
      desc: ''
    },
    sensor: {
      name: 'Products',
      desc: ''
    },
    IHUB1S: {
      title: 'XIOT-IHUB1S Intelligent Box',
      name: 'IHUB1S Intelligent Box',
      desc: 'Realize Intelligent Linkage Between Devices'
    },
    IFC16S: {
      title: 'XIOT-IFC13S Farm Camera',
      name: 'IFC13S Farm Camera',
      desc: '1300W Image Camera, Remote Agricultural Monitoring'
    },
    ISM50: {
      title: 'XIOT-ISM50S Soil Monitor',
      name: 'ISM50S Soil Monitor',
      desc: 'Multi-layer Soil Monitoring'
    },
    IWS7: {
      title: 'XIOT-IWS7S Weather Station',
      name: 'IWS7S Weather Station',
      desc: 'Master Your Farm-level Microclimate in Precision'
    },
    IWS3: {
      title: 'XIOT-IWS3S Weather Station',
      name: 'IWS3S Weather Station',
      desc: 'Accurate Measurement Of Three Elements Of Meteorology'
    },
    IFC16: {
      title: 'XIOT-IFC16 Farm Camera',
      name: 'IFC16 Farm Camera',
      desc: '1600W Image Camera, Remote Agricultural Monitoring'
    },
    all: {
      title: 'XIOT-Products',
      name: 'More',
      desc: '...'
    },
    parts: {
      name: 'Fittings',
      desc: ''
    },
    solar: {
      title: 'XIOT-Solar Power Panel',
      name: 'Solar Power Panel',
      desc: 'Convenient power supply'
    },
    fixedbanister: {
      title: 'XIOT-Fixed Pole',
      name: 'Fixed Pole',
      desc: 'Easy to install'
    },
    wire: {
      title: 'XIOT-One-divided-two Wire',
      name: 'One-divided-two Wire',
      desc: 'Expand more equipments'
    },
    api: {
      title: 'XIOT-API',
      name: 'API',
      desc: ''
    },
    service: {
      title: 'XIOT-Service',
      name: 'Service',
      desc: ''
    },
    guide: {
      title: 'XIOT-Guide',
      name: 'Guide',
      desc: 'Use products better'
    },
    afterMarket: {
      title: 'XIOT-Support',
      name: 'Support',
      desc: 'After sales policy, equipment warranty'
    },
    download: {
      title: 'XIOT-Download',
      name: 'Download',
      desc: 'Product introduction, operation instructions and specification parameters etc'
    },
    question: {
      title: 'XIOT-Q&A',
      name: 'Q&A',
      desc: 'FAQ summary of common problems'
    },
    community: {
      title: 'XIOT-Community',
      name: 'Community',
      desc: ''
    },
    IFC16SInstall: {
      title: 'XIOT-IFC16S Farm Camera Installation Guide'
    },
    ISM50Install: {
      title: 'XIOT-ISM50 Soil Monitor Installation Guide'
    },
    IWS7Install: {
      title: 'XIOT-IWS7 Weather Station Installation Guide'
    },
    IWS3Install: {
      title: 'XIOT-IWS3 Weather Station Installation Guide'
    },
    FM1Install: {
      title: 'XIOT-FM1 Installation Guide'
    },
    FM2Install: {
      title: 'XIOT-FM2 Installation Guide'
    },
    IFC16Install: {
      title: 'XIOT-IFC16 Farm Camera Installation Guide'
    },
    solarInstall: {
      title: 'XIOT-Solar Power Panel Installation Guide'
    },
    FixedPoleInstall: {
      title: 'XIOT- Fixed Pole Outdoor Installation Tutorial Guide'
    },
    user: {
      title: 'XIOT-User Center'
    },
    platform: {
      title: 'XIOT-Platform Center'
    },
    userhome: {
      title: 'XIOT-My Homepage'
    },
    help: {
      title: 'XIOT-Help',
      name: 'Help',
      desc: ''
    }
  },
  users: {
    signin: 'Sign in',
    signup: 'Sign up',
    user: 'User Center',
    platform: 'Platform Center',
    data: 'XIoT Hub',
    homepage: 'My Homepage',
    logout: 'Log Out'
  },
  // 首页
  index: {
    banner: {
      xiot: 'XIOT Platform',
      desc: 'Connecting land, crops, farmers and consumers'
    },
    intro: {
      title: 'Agricultural IoT platform',
      desc: 'Provides a variety of agricultural solutions, a variety of meteorological hardware products, multi terminal software products, open platform, and supports diversified equipment access. Provide data collection, visualization and automatic management for the planting and management of agricultural products, meet the needs of enterprises and farmers to build the overall solution of smart agriculture, improve the planting efficiency and reduce the cost'
    },
    possibilities: {
      title: 'More possibilities',
      tab1: {
        title: 'Perfect solution',
        desc: 'Provide agricultural irrigation, planting solutions, improve traditional planting'
      },
      tab2: {
        title: 'Multi category, scalable intelligent hardware',
        desc: 'Self developed a variety of meteorological equipment, which can expand the hardware ecology and provide more equipment support'
      },
      tab3: {
        title: 'Safe and reliable open platform',
        desc: 'Provide accessible intelligent hardware platform and API documents'
      },
      tab4: {
        title: 'Multi terminal software',
        desc: 'Provide multi terminal remote management and monitoring of app, wechat-applet and website'
      },
      tab5: {
        title: 'Value added services',
        desc: 'Pre installed SIM card to support data service purchase'
      }
    },
    framework: {
      title: 'Product Architecture'
    },
    contact: {
      title: 'Contact us',
      tab1: {
        title: '400-980-3131',
        desc: 'Hotline'
      },
      tab2: {
        title: '',
        desc: 'Scanning code and focusing on “极飞物联”'
      }
    }
  },
  // 水稻案例
  paddy: {
    title: 'Rice Irrigation Solution',
    intro: {
      title: 'Brief introduction',
      desc: 'In the rice irrigation scenario scheme, the agricultural IoT technology is used, intelligent box linkage intelligent gate valve, intelligent motor and software remote intelligent control are adopted to realize the node control of pump room, field grid and ditch in the irrigation process, so as to achieve the purpose of reasonable irrigation. At the same time, the simple layout scheme has a wide range of applicability, can be used with the installation, is safe and reliable, and minimizes manual intervention, gradually realize less people and unmanned management.'
    },
    flow: {
      title: 'Core process',
      tab1: {
        title: 'Pump house management',
        desc: 'Motor controlled gate switch liquid level device to monitor water level'
      },
      tab2: {
        title: 'Field management',
        desc: 'Automatic gate valve control of water inlet and drainage pipe in field canal'
      },
      tab3: {
        title: 'Lateral canal management',
        desc: 'Motor controlled gate switch'
      }
    },
    hardware: {
      title: 'Hardware ecology',
      tab1: 'iHub',
      tab2: 'Electric gate valve',
      tab3: 'Liquid level meter',
      tab4: 'Electric machinery'
    },
    painPoint: {
      title: 'Solve pain points',
      tab1: {
        title: 'Wide applicability',
        desc: 'The irrigation management system, which integrates sensor technology, communication technology and computer technology, is more applicable'
      },
      tab2: {
        title: 'Reduce cost and improve efficiency',
        desc: 'Using automatic water level gauge, weather sensor, intelligent irrigation and drainage, no need of human participation, reduce the cost'
      },
      tab3: {
        title: 'Multi mode management',
        desc: 'Support timing irrigation, periodic irrigation, manual irrigation and other modes, start and stop at any time'
      },
      tab4: {
        title: 'Real time exception reminder',
        desc: 'Support background abnormal warning function, reduce artificial exploration of rice field abnormality'
      },
      tab5: {
        title: 'Data recording and traceability',
        desc: 'Support the recording of real-time data, statistical data, easy to follow-up research or data view'
      }
    }
  },
  // 棉田案例
  cotton: {
    title: 'Cotton Field Irrigation Solution',
    intro: {
      title: 'Brief introduction',
      desc: 'The cotton field irrigation scene scheme, using the Agricultural Internet of things technology, adopts the intelligent box linkage intelligent motor, liquid level meter, controller, etc., uses the software remote intelligent control of cotton field irrigation water storage, pump room, fertilization, drip irrigation node, to achieve the purpose of drip irrigation, at the same time, the simple layout scheme, has a wide range of applicability, with the installation and use, safe and reliable, to minimize manual intervention, Gradually realize less people and unmanned management.'
    },
    flow: {
      title: 'Core process',
      tab1: {
        title: 'Reservoir management',
        desc: 'Automatic control of canal gate to maintain reservoir water level'
      },
      tab2: {
        title: 'Pump house management',
        desc: 'Automatic control of pump station operation according to rotation irrigation cycle'
      },
      tab3: {
        title: 'Fertilization management',
        desc: 'Precise control of fertilizer applicator, nitrogen, phosphorus, potassium fertilizer'
      },
      tab4: {
        title: 'Drip irrigation management',
        desc: 'Control the outlet valve of drip irrigation belt'
      }
    },
    hardware: {
      title: 'Hardware ecology',
      tab1: 'iHub',
      tab2: 'Electric gate valve',
      tab3: 'Liquid level meter',
      tab4: 'Electric machinery'
    },
    painPoint: {
      title: 'Solve pain points',
      tab1: {
        title: 'Wide applicability',
        desc: 'The irrigation management system, which integrates sensor technology, communication technology and computer technology, is more applicable'
      },
      tab2: {
        title: 'Reduce cost and improve efficiency',
        desc: 'Using automatic water level gauge, weather sensor, intelligent irrigation and drainage, no need of human participation, reduce the cost'
      },
      tab3: {
        title: 'Multi mode management',
        desc: 'Support timing irrigation, periodic irrigation, manual irrigation and other modes, start and stop at any time'
      },
      tab4: {
        title: 'Real time exception reminder',
        desc: 'Support background abnormal warning function, reduce artificial exploration of rice field abnormality'
      },
      tab5: {
        title: 'Data recording and traceability',
        desc: 'Support the recording of real-time data, statistical data, easy to follow-up research or data view'
      }
    }
  },
  // 产品溯源
  trace: {
    title: 'Product Traceability Solution',
    intro: {
      title: 'Brief introduction',
      desc: 'The product traceability solution scenario uses various meteorological equipment and camera equipment to record the planting process of agricultural products, independently edit and generate traceability codes, provide food traceability and agricultural information display for agricultural products, improve the value of agricultural products and increase sales.'
    },
    flow: {
      title: 'Trace process',
      tab1: {
        title: 'Planting stage',
        desc: 'Record each stage of product planting'
      },
      tab2: {
        title: 'Processing stage',
        desc: 'Record all stages of product planting and monitor the products entering the processing stage'
      },
      tab3: {
        title: 'Storage stage',
        desc: 'Products are placed in storage and waiting for transportation for sales all over the country'
      },
      tab4: {
        title: 'Sales stage',
        desc: 'Consumers scan code to trace product source'
      }
    },
    painPoint: {
      title: 'Solve pain points',
      tab1: {
        title: 'Custom code scanning page',
        desc: 'Provide a definable code scanning page, which can define product information and define product life cycle information management, so as to realize the traceability of each stage'
      },
      tab2: {
        title: 'Life cycle management',
        desc: 'The IFC13S can automatically collect the data of product planting, processing, storage, sales and other stages, and provide real-time HD data'
      },
      tab3: {
        title: 'Build brand and increase advantages',
        desc: 'Tracing the product life cycle in a green and transparent manner and establishing traceability files are conducive to building product safety, credibility, highlighting advantages and improving product brand'
      },
      tab4: {
        title: 'Improve product sales',
        desc: "Provide product quality traceability, enhance consumers' trust, broaden users' sources and stimulate consumers' purchasing power"
      }
    }
  },
  // 所有产品页
  all: {
    title: 'Products',
    prods: {
      title: 'Products',
      ihub: {
        pre_title: 'XAG IHUB1S', // 名称前缀
        title: 'Intelligent Box',
        desc: 'Realize Intelligent Linkage Between Devices'
      },
      fc2: {
        title: 'XAG IFC13S Farm Camera',
        desc: 'Capture Your Land in Every Detail'
      },
      sm: {
        title: 'XAG ISM50S Soil Monitor',
        desc: 'Understand Where Your Food Begins'
      },
      ht: {
        title: 'XAG IWS3S Weather Station',
        desc: 'Sense the Slightest Change of Farm Humiture'
      },
      ws: {
        title: 'XAG IWS7S Weather Station',
        desc: 'Seeing the Invisible. All-in-one Microclimate Monitor'
      },
      fc1: {
        title: 'XAG IFC16 Farm Camera',
        desc: 'Recording HD images for the whole growth process'
      }
    },
    parts: {
      title: 'Parts',
      solar: {
        title: 'Solar Power Panel',
        desc: 'Convenient Power Supply for Outdoors'
      },
      banister: {
        title: 'Fixed Pole',
        desc: 'Easy to install and deploy'
      }
    }
  },
  // 产品
  prods: {
    fm1: {
      title: 'FM1 Field Monitor',
      desc: 'With the Wechat Mini Program, Feild Monitor not only realizes real-time collection of high-definition images and meteorological data, but also makes remote monitoring possible.',
      tab1: {
        tips: 'Dual Cameras, Wide Vision',
        desc: 'Automatically generates 160° hi-res images. Monitoring range can be up to 3.33 hectares in plain areas'
      },
      tab2: {
        tips: 'Precision Monitoring, Real-time Collection',
        desc: 'High integration sensors adopted, FM1 can collect environment temperature, humidity, air pressure and light intensity',
        details: {
          temp: 'Temperature',
          humidity: 'Humidity',
          air: 'Pressure',
          light: 'Light intensity'
        }
      },
      tab3: {
        tips: 'Real-time Data Transmission',
        desc: 'Data and images update every 15min and transmit to the Cloud through 4G network simultaneously'
      },
      tab4: {
        tips: 'Wechat Mini Program, Remote Monitoring',
        desc: 'Users can view the real-time meteorological data, photos, and videos taken by FM1 via the Wechat mini program “XIoT Hub”'
      },
      tab5: {
        tips: 'Solar Power Supply, Easy Installation',
        desc: 'With the built-in high capacity but low consumption batteries, no electric wire is needed. FM2 can keep working in the rainy weather for 7 days'
      },
      tab6: {
        tips: 'Precision GPS Positioning',
        desc: 'Users can know about the accurate installation position of FM1 through the map, so it is convenient to manage several equipment at the same time'
      },
      details: {
        name: 'Specifications',
        mbd: 'Main Body Dimensions',
        spd: 'Solar Panel Dimensions',
        pd: 'Pole Dimensions',
        spp: 'Solar Panel Power',
        cam: 'Camera',
        bc: 'Battery Capacity',
        imr: 'Illumination Measurement Range',
        tmr: 'Temperature Measurement Range',
        hmr: 'Humidity Measurement Range',
        apmr: 'Air Pressure Measurement Range'
      }
    },
    fm2: {
      title: 'FM2 Field Monitor',
      desc: 'With the Field Monitor created by XAG, users can inquire and monitor the weather condition  in real time through WeChat Mini Program.',
      tab1: {
        tips: 'Precision Monitoring, Real-time Collection',
        desc: 'Integrated several advanced sensors, FM2 can collect real-time meteorological data, such as precipitation, wind speed, and wind direction',
        details: {
          rain: 'Rainfall',
          wind: 'Wind speed',
          windd: 'Wind direction'
        }
      },
      tab2: {
        tips: 'Soil Monitoring Expansion',
        desc: 'It can be flexibly selected according to needs, and the module includes monitoring data of soil, temperature and water content'
      },
      tab3: {
        tips: 'Real-time Data Transmission',
        desc: 'Data and images update every 15min and transmit to the Cloud through 4G network simultaneously'
      },
      tab4: {
        tips: 'Wechat Mini Program, Remote Monitoring',
        desc: 'Users can view the real-time meteorological data via the Wechat mini program “XIoT Hub”'
      },
      tab5: {
        tips: 'Solar Power Supply, Easy Installation',
        desc: 'With the built-in high capacity but low consumption batteries, no electric wire is needed. FM2 can keep working in the rainy weather for 7 days'
      },
      tab6: {
        tips: 'Precision GPS Positioning',
        desc: 'Users can know about the accurate installation position of FM2 through the map, so it is convenient to manage several equipment at the same time'
      },
      details: {
        name: 'Specifications',
        mbd: 'Main Body Dimensions',
        spd: 'Solar Panel Dimensions',
        pd: 'Pole Dimensions',
        spp: 'Solar Panel Power',
        bc: 'Battery Capacity',
        wsp: 'Wind Speed Precision',
        swcp: 'Soil Water Content Precision',
        stp: 'Soil Temperature Precision',
        rr: 'Rainfall Resolution',
        wsmr: 'Wind Speed Measurement Range',
        smcmr: 'Soil moisture content Measurement Range',
        swcmr: 'Soil Water Content Measurement Range',
        stmr: 'Soil Temperature Measurement Range'
      }
    },
    fc1: {
      title1: 'XAG',
      title2: '',
      title3: 'IFC16 Farm Camera',
      desc: "IFC16 Farm Camera is an HD image acquisition device in the XIoT System. It records a thorough process of crop growth. It's able to provide supporting data for crop growth analysis and product traceability.",
      tab1: {
        tips: 'HD Images',
        desc: 'megapixel HD images, presenting every detail of crop growth along the way',
        details: {
          plant: 'Planting',
          bud: 'Germination',
          grow: 'Growth'
        }
      },
      tab5: {
        tips: 'Water and Dust Proof',
        desc: 'Withstanding adverse weather outdoors, remain functional despite being in a storm or a desert'
      },
      tab2: {
        tips: 'Real-time Data Synchronize',
        desc: 'images updates every 30 minutes, and will be synchronized to the cloud in real-time via the 4G network'
      },
      tab3: {
        tips: 'High Capacity Battery',
        desc: 'Built-in 12000mAh high capacity battery, sustainable for 14 days under cloudy weather',
        details: {
          battery: 'High Capacity Battery',
          day: '14-day Battery Life'
        }
      },
      tab4: {
        tips: 'GPS Positioning',
        desc: 'Users can learn the location of the device intuitively through the map, which is convenient to manage multiple devices at the same time'
      },
      details: {
        name: 'Specifications',
        ws: {
          title: 'Weight and Dimensions',
          value1: '596g',
          value2: '67.2*67.2*148mm'
        },
        temp: {
          title: 'Operational Temperature',
          value: '-20~60℃'
        },
        usb: {
          title: 'USB Charging and Battery Capacity',
          value1: '5V~2A',
          value2: '12000mAh'
        },
        focallength: {
          title: 'Field of View',
          value: 'Diagonal 95°'
        },
        lens: {
          title: 'Focus and Pixel',
          value1: '3.8mm',
          value2: '16M'
        },
        sensor: {
          title: 'Sensor Type',
          value: '1/2.3CMOS'
        },
        image: {
          title: 'Max. Image Resolution',
          value: '4608*3456'
        },
        grid: {
          title: 'Network Type',
          value1: 'Supports China Mobile/Unicom/Telecom',
          value2: '4G/3G/2G'
        },
        protective: {
          title: 'Protection Rating',
          value: 'IP65'
        }
      }
    },
    fc2: {
      title1: 'XAG',
      title2: '',
      title3: 'IFC13S Farm Camera',
      desc: 'Capture Your Land in Every Detail',
      tab_nav: {
        item1: 'Introduce',
        item2: 'Specifications'
      },
      tab1: {
        item1: {
          tips: '1300W Image Camera',
          desc: 'High-resolution. Further and Clearer.'
        },
        item3: {
          tips: 'Live-streaming',
          desc: 'Go Live with Your Farm'
        },
        item4: {
          tips: 'IP65 Water and Dust Resistant',
          desc: 'Protection built for tough environments.'
        },
        item5: {
          tips: 'Cloud Monitoring',
          desc: 'Manage your devices via PC or smartphone.'
        },
        item6: {
          tips: 'Real-time Sharing',
          desc: '4G supported. Share your farm anywhere, anytime.'
        }
      },
      tab2: {
        tips: 'Safety Traceability System',
        desc: 'Generate QR code for each product, trace brand information, product certification information, real-time photos, show transparently in the whole process, and create a product brand.'
      },
      tab3: {
        tips1: '',
        tips2: 'Interval Shot, Snap Every Single Moment of Your Crops.',
        desc: 'With interval timer shooting mode, IFC13S Farm Camera takes field photos at any selected interval and automatically integrates all images into a day-to-night time-lapse video. Take a closer look into a specific crop growth moment or enjoy a video playback to explore the journey of your crops experience.',
        dates: {
          date1: '2019-07-12',
          date2: '2019-07-27',
          date3: '2019-08-15',
          date4: '2019-08-25',
          date5: '2019-09-20'
        }
      },
      tab5: {
        tips: 'Introduce Live-Streaming Feature. Go Live with Your Farm.',
        desc: 'Simply press a button on your phone or computer to switch into the live mode. Turning your terminal device into a farm showroom, IFC13S Farm Camera enables farmers to check out thier crop condition and monitor every farming activities, such as seeding, fertilisation and spraying, in real time.'
      },
      tab6: {
        tips: 'Designed to Withstand Water and Dust. Indoors and Out.',
        desc: 'Built with IP65 protection level, IFC13S Farm Camera is ready to effectively operate under various outdoor environment, no matter paddy field, hills, mountains or desert. It can also handle heat, storms and snow.'
      },
      tab7: {
        tips: 'Multi-device Management. Monitor from Anywhere You Like.',
        desc: 'Either at home or on the go, farmers can track the real-time status of their farmlands and identify any potential crop disease on their PC or smartphone. Embedded GPS enables accurate equipment distribution management.'
      },
      tab8: {
        tips: 'Support 4G Network.One Tap to Share Your Farm Views.',
        desc: 'Crop images and data would be simultaneously transmitted to the cloud through high-speed 4G network. Just one touch to post your farm view and share your joy of harvest to anyone who matter. '
      },
      tab9: {
        tips: 'Solar Power Supply, Operating even on Rainy Days.',
        desc: 'Wiring free and easy-to-assemble, the IP67 Solar Panel has a built-in 7500mAh battery to unleash powerful, eco-friendly energy. IFC13S Farm Camera can keep working during rainy weather for 15 consecutive days.',
        details: {
          item1: {
            title: 'Input Voltage',
            value: '5~16V'
          },
          item2: {
            title: 'Output Voltage',
            value: '15V/2A'
          },
          item3: {
            title: 'Battery Capacity',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: 'Solar Panel Power',
            value: '15W'
          },
          item5: {
            title: 'Operating Temperature',
            value: '-20~60℃'
          },
          item6: {
            title: 'IP Rating',
            value: 'IP67'
          },
          item7: {
            title: 'Weight',
            value: '1370g'
          },
          item8: {
            title: 'Dimensions',
            value: 'L401×W256×H35.4mm'
          }
        }
      },
      tab10: {
        tips: 'IFC13S Farm Camera is Safeguarding Our Lands Around the Globe.',
        case1: {
          title: 'Ant Forest',
          desc: 'Witness the largest public welfare project in the history of mankind.'
        },
        case2: {
          title: 'Vineyard',
          desc: 'Real-time crop monitoring to help produce the finest wine in Australian Vineyard.'
        },
        case3: {
          title: 'iBlackSoil Rice Farm',
          desc: 'Collect crop growth images to guide rice-farming activities in Northeast China.'
        },
        case4: {
          title: 'Honey Pomelo Farm',
          desc: 'Make honey pomelo production more traceable and transparent in Fujian, China.'
        },
        case5: {
          title: 'Dragon Fruit Farm',
          desc: 'Help growers produce high-quality dragon fruits in Hainan, China.'
        }
      },
      tab11: {
        title: 'Other products that you might be interested in.',
        item1: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IHUB1S Intelligent Box'
        },
        item2: {
          title1: 'XAG',
          title2: '',
          title3: 'ISM50S Soil Monitor'
        },
        item3: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS7S Weather Station'
        },
        item4: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS3S Weather Station'
        }
      },
      tab12: {
        title: 'Appearance',
        weight: 'Weight 220g'
      },
      details: {
        name: 'Specifications',
        item1: {
          title: 'Voltage',
          value: '5~15V'
        },
        item2: {
          title: 'Power Mode',
          value: 'Solar Panel/USB Charging '
        },
        item3: {
          title: 'Operating Temperature',
          value: '-20~60 ℃ '
        },
        item4: {
          title: 'IP Rating',
          value: 'IP65'
        },
        item5: {
          title: 'Network Type',
          value: '4G/WiFi/Bluetooth '
        },
        item6: {
          title: 'Positioning',
          value: 'GPS/Base Station '
        },
        item7: {
          title: 'Supporting Carriers',
          value: 'China Mobile / China Unicom / China Telecom / China Telecom SIM Integrated '
        },
        item8: {
          title: 'Resolution Ratio',
          value: '1300M'
        },
        item9: {
          title: 'Focus',
          value: '3.57 mm'
        },
        item10: {
          title: 'Horizontal FOV',
          value: '67.9° '
        },
        item11: {
          title: 'Vertical FOV',
          value: '53.7° '
        },
        item12: {
          title: 'Diagonal FOV',
          value: '80°'
        },
        item13: {
          title: 'Voice',
          value: 'Recording Support'
        },
        item14: {
          title: 'Video Frame Rate',
          value: '720p@25fps'
        },
        item15: {
          title: 'Night Vision Range',
          value: 'Unsupported'
        }
      }
    },
    sm: {
      title1: 'XAG',
      title2: '',
      title3: 'ISM50S Soil Monitor',
      desc: 'Understand Where Your Food Begins',
      tab_nav: {
        item1: 'Introduce',
        item2: 'Specifications'
      },
      tab1: {
        item1: {
          tips: 'Comprehensive Monitoring',
          desc: 'Monitor soil temperature, moisture and fertility simultaneously.'
        },
        item2: {
          tips: 'In-depth Detection',
          desc: '5-layer high accuracy detection, even around the root.'
        },
        item3: {
          tips: 'IP68 Protection',
          desc: 'Prevent core sensors from dust and water immersion.'
        },
        item4: {
          tips: 'App Threshold Alert',
          desc: 'Immediately get informed when soil abnormity happens.'
        },
        item5: {
          tips: 'Cloud Monitoring',
          desc: 'Manage your devices via PC or smartphone.'
        },
        item6: {
          tips: 'Real-time Sharing',
          desc: '4G supported. Share your farm anywhere, anytime.'
        }
      },
      tab2: {
        tips: '5-layer Soil Monitoring. In More Depth',
        desc: 'With IP68 sensors buried up to 50cm into the ground, ISM50S Soil Monitor is designed to accurately measure three of the most important soil parameters, including soil temperature, moisture and fertility (electric conductivity), for five different soil layers.'
      },
      tab3: {
        tips: "Real-time Soil Condition Reporting. Act, before It's Too Late.",
        desc: 'Simply download a Mobile App and connect it with ISM50S Soil Monitor to review soil data instantly on your smartphone, wherever and whenever. If one of the soil parameters reaches or exceeds the defined threshold you set, an App alert would inform you of the abnormity to facilitate timely actions. '
      },
      tab4: {
        tips: 'Multi-device Management. Monitor from Anywhere You Like.',
        desc: 'Either at home or on the go, farmers can track the real-time soil condition of their farmlands and conduct remote analysis of soil health on their PC or smartphone. Embedded GPS positioning enables accurate equipment distribution management.'
      },
      tab5: {
        tips: 'Support 4G Network.One Tap to Share and Make it Transparent.',
        desc: 'Soil data would be simultaneousl  transmitted to the cloud through high-speed 4G network. Just one touch to share with anyone on social media, telling the world that your agricultural produce is grown from healthy soil.'
      },
      tab6: {
        tips: 'Solar Power Supply, Operating even on Rainy Days.',
        desc: 'Wiring free and easy-to-assemble, the IP67 Solar Panel has a built-in 7500mAh battery to unleash powerful, eco-friendly energy. ISM50S Soil Monitor can keep working during rainy weather for 15 consecutive days.',
        details: {
          item1: {
            title: 'Input Voltage',
            value: '5~16V'
          },
          item2: {
            title: 'Output Voltage',
            value: '15V/2A'
          },
          item3: {
            title: 'Battery Capacity',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: 'Solar Panel Power',
            value: '15W'
          },
          item5: {
            title: 'Operating Temperature',
            value: '-20~60℃'
          },
          item6: {
            title: 'IP Rating',
            value: 'IP67'
          },
          item7: {
            title: 'Weight',
            value: '1370g'
          },
          item8: {
            title: 'Dimension',
            value: 'L401*W256*H354mm'
          }
        }
      },
      tab7: {
        tips: 'Multi-scenario Applications',
        case1: 'Soil Improvement for Greenhouse Growing',
        case2: 'Orchard Soil Moisture Monitoring',
        case3: 'Water Pollution Control',
        case4: 'Quick Soil Test',
        case5: 'Precise irrigation to conserve agricultural water'
      },
      tab8: {
        title: 'Other products that you might be interested in.',
        item1: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IHUB1S Intelligent Box'
        },
        item2: {
          title1: 'XAG',
          title2: '',
          title3: 'IFC13S Farm Camera'
        },
        item3: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS7S Weather Station'
        },
        item4: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS3S Weather Station'
        }
      },
      tab9: {
        title: 'Appearance',
        weight: 'Weight  1150g'
      },
      details: {
        name: 'Specifications',
        item1: {
          title: 'Voltage',
          value: '5~15V'
        },
        item2: {
          title: 'Power Mode',
          value: 'Solar Panel/USB Charging '
        },
        item4: {
          title: 'IP Rating',
          value: 'Mainframe IP65/Sensor IP68'
        },
        item5: {
          title: 'Network Type',
          value: '4G/WiFi/Bluetooth '
        },
        item6: {
          title: 'Positioning',
          value: 'GPS/Base Station '
        },
        item7: {
          title: 'Supporting Carriers',
          value: 'China Mobile / China Unicom / China Telecom / China Telecom SIM Integrated '
        },
        item8: {
          title: 'Soil Temperature Measurement Range',
          value: '-30~80℃ '
        },
        item9: {
          title: 'Soil Moisture Measurement Range',
          value: '0~100% '
        },
        item10: {
          title: 'Soil EC Measurement Range ',
          value: '0~4mS/cm '
        },
        item11: {
          title: 'Soil Temperature Accuracy ',
          value: '±0.5℃ '
        },
        item12: {
          title: 'Soil Moisture Accuracy ',
          value: '±5% '
        },
        item13: {
          title: 'Soil EC Accuracy',
          value: '±10%'
        }
      }
    },
    ws: {
      title1: 'XAG',
      title2: '',
      title3: 'IWS7S Weather Station',
      desc: 'Seeing the Invisible. All-in-one Microclimate Monitor',
      tab_nav: {
        item1: 'Introduce',
        item2: 'Specifications'
      },
      tab1: {
        item1: {
          tips: 'Comprehensive Monitoring',
          desc: 'Monitor 6 meteorological factors simultaneously.'
        },
        item2: {
          tips: 'IP65 Water and Dust Resistant',
          desc: 'Protection built for tough environments.'
        },
        item3: {
          tips: 'App Threshold Alert',
          desc: 'Immediately get informed when abnormal weather strikes.'
        },
        item4: {
          tips: 'Cloud Monitoring',
          desc: 'Manage your devices via PC or smartphone.'
        },
        item5: {
          tips: 'Solar Power Supply',
          desc: 'No need of wiring. Not afraid from rainy days.'
        },
        item6: {
          tips: 'Real-time Sharing',
          desc: '4G supported. Share your farm anywhere, anytime.'
        }
      },
      tab2: {
        tips: 'Master Your Farm-level Microclimate in Precision.',
        desc: 'Designed to measure field-level climate and guide precision farming practices, IWS7S Weather Station monitors seven meteorological factors (e.g., temperature, rainfall, humidity, barometric pressure, wind speed/direction and illuminance) through its high-accuracy advanced sensors. ',
        attr: {
          rainfall: {
            title: 'Rainfall',
            value: '±5%mm'
          },
          light: {
            title: 'Illuminance',
            value: '±15%'
          },
          wind_speed: {
            title: 'Wind Speed',
            value: '±1m/s'
          },
          wind_direction: {
            title: 'Wind Direction',
            value: '±22.5°'
          },
          temperature: {
            title: 'Temperature',
            value: '±0.2℃',
            tips: ''
          },
          pressure: {
            title: 'Barometric Pressure',
            value: '±4hPa'
          },
          humidity: {
            title: 'Moisture',
            value: '±5%',
            tips: ''
          }
        }
      },
      tab3: {
        tips: 'Made to Last. Withstand Water and Dust Indoors and Out.',
        desc: 'Built with IP65 protection level, IWS7S Weather Station can apply to a wide range of outdoor environments, no matter paddy field, hills, mountains or desert. It can also handle heat, storms and snow. '
      },
      tab4: {
        tips: 'Real-time Weather Alert. ',
        desc: 'When any of the seven parameters exceeds the pre-set threshold, an instant alert to abnormal weather would be sent to you on mobile App.'
      },
      tab5: {
        tips: 'Multi-device Management. Monitor from Anywhere You Like.',
        desc: 'Either at home or on the go, farmers can track the field-specific weather condition through their PC or smartphone and make timely decision to minimise the risk of any abnormal weather. Embedded GPS positioning enables accurate equipment distribution management.'
      },
      tab6: {
        tips: 'Support 4G Network.One Tap to Share and Make it Transparent.',
        desc: 'All data would be simultaneously transmitted to the cloud through high-speed 4G network. Just one touch to share with anyone who matter, such as your customers, staffs and consultants.'
      },
      tab7: {
        tips: 'Solar Power Supply, Operating even on Rainy Days.',
        desc: 'Wiring free and easy-to-assemble, the IP67 Solar Panel has a built-in 7500mAh battery to unleash powerful, eco-friendly energy. IWS7S Weather Station can keep working during rainy weather for 15 consecutive days.',
        details: {
          item1: {
            title: 'Input Voltage',
            value: '5~16V'
          },
          item2: {
            title: 'Output Voltage',
            value: '15V/2A'
          },
          item3: {
            title: 'Battery Capacity',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: 'Solar Panel Power',
            value: '15W'
          },
          item5: {
            title: 'Operating Temperature',
            value: '-20~60℃'
          },
          item6: {
            title: 'IP Rating',
            value: 'IP67'
          },
          item7: {
            title: 'Weight',
            value: '1370g'
          },
          item8: {
            title: 'Dimension',
            value: 'L401*W256*H354mm'
          }
        }
      },
      tab8: {
        tips: 'Multi-scenario Applications',
        case1: 'Precision Agriculture',
        case2: 'Industrial Inspection',
        case3: 'Regulatory Meteorological Monitoring',
        case4: 'Hydrological Monitoring',
        case5: 'Wildfire Management'
      },
      tab9: {
        title: 'Other products that you might be interested in.',
        item1: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IHUB1S Intelligent Box'
        },
        item2: {
          title1: 'XAG',
          title2: '',
          title3: 'IFC13S Farm Camera'
        },
        item3: {
          title1: 'XAG',
          title2: '',
          title3: 'ISM50S Soil Monitor'
        },
        item4: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS3S Weather Station'
        }
      },
      tab10: {
        title: 'Appearance',
        weight: 'Weight  550g'
      },
      details: {
        name: 'Specifications',
        item1: {
          title: 'Voltage',
          value: '5~15V'
        },
        item2: {
          title: 'Power Mode',
          value: 'Solar Panel/USB Charging '
        },
        item3: {
          title: 'Operating Temperature ',
          value: '-20~60℃ '
        },
        item4: {
          title: 'IP Rating',
          value: 'IP65'
        },
        item5: {
          title: 'Network Type',
          value: '4G/WiFi/Bluetooth '
        },
        item6: {
          title: 'Positioning',
          value: 'GPS/Base Station '
        },
        item7: {
          title: 'Supporting Carriers',
          value: 'China Mobile / China Unicom / China Telecom / China Telecom SIM Integrated '
        },
        item8: {
          title: 'Temperature Measurement Range',
          value: '-20~60℃ '
        },
        item9: {
          title: 'Moisture Measurement Range',
          value: '0~100%RH'
        },
        item10: {
          title: 'Barometric Pressure Measurement Range',
          value: '300～1100hPa  '
        },
        item11: {
          title: 'Rainfall Measurement Range ',
          value: '0~200mm/h '
        },
        item12: {
          title: 'Illuminance Measurement Range',
          value: '1~125000Lux  '
        },
        item13: {
          title: 'Wind Speed Measurement Range',
          value: '0～15m/s '
        },
        item14: {
          title: 'Wind Direction Measurement Range',
          value: '0～360° '
        },
        item15: {
          title: 'Temperature Accuracy',
          value: '±0.2℃'
        },
        item16: {
          title: 'Moisture Accuracy',
          value: '±5%'
        },
        item17: {
          title: 'Barometric Pressure Accuracy',
          value: '±4hPa  '
        },
        item18: {
          title: 'Rainfall Accuracy',
          value: '±5% '
        },
        item19: {
          title: 'Illuminance Accuracy',
          value: '±15%  '
        },
        item20: {
          title: 'Wind Speed Accuracy',
          value: '±1 m/s '
        },
        item21: {
          title: 'Wind Direction Accuracy',
          value: '±22.5° '
        }
      }
    },
    ht: {
      title1: 'XAG',
      title2: '',
      title3: 'IWS3S Weather Station',
      desc: 'Sense the Slightest Change of Farm Humiture',
      tab_nav: {
        item1: 'Introduce',
        item2: 'Specifications'
      },
      tab1: {
        item1: {
          tips: 'Precision Humiture Monitoring',
          desc: 'Temperature and humidity in your control.'
        },
        item2: {
          tips: 'IP65 Water and Dust Resistant',
          desc: 'Protection built for tough environments.'
        },
        item3: {
          tips: 'App Threshold Alert',
          desc: 'Immediately get informed when humiture changes unexpectedly.'
        },
        item4: {
          tips: 'Cloud Monitoring',
          desc: 'Manage your devices via PC or smartphone.'
        },
        item5: {
          tips: 'Solar Power Supply',
          desc: 'No need of wiring. Not afraid from rainy days.'
        },
        item6: {
          tips: 'Real-time Sharing',
          desc: '4G supported. Share your farm anywhere, anytime.'
        }
      },
      tab2: {
        tips: 'Temperature and Humidity Measurement at Farm Level.',
        desc: 'Accurately measure two of the most common and important weather indicators, temperature and humidity, to guide precision farming practices.',
        attr: {
          temperature: {
            title: 'Temperature',
            value: '±0.2℃',
            tips: ''
          },
          humidity: {
            title: 'Moisture',
            value: '±5%',
            tips: ''
          }
        }
      },
      tab3: {
        tips: 'Real-time Monitoring with Threshold Alert.',
        desc: 'When temperature or humidity on fields exceeds the pre-set threshold, farmers would instantly get an alert to abnormity and take timely actions to minimise crop damage risks.'
      },
      tab4: {
        tips: 'Made to Last. Withstand Water and Dust. Indoor and Out.',
        desc: 'Able to operation under a wide range of indoor and outdoor environments, no matter greenhouse, paddy field, hills, mountains or desert. With IP65 protection level, HydroThermo1 can also handle heat, storms and snow. '
      },
      tab5: {
        tips: 'Multi-device Management. Monitor from Anywhere You Like.',
        desc: 'Either at home or on the go, farmers can track both temperature and humidity through their PC or smartphone. Immediately react to any humiture abnormity that might cause crop damage.mbedded GPS positioning enables accurate equipment distribution management.'
      },
      tab6: {
        tips: 'Support 4G Network. One Tap to Share and Make it Transparent.',
        desc: 'All data would be simultaneously transmitted to the cloud through high-speed 4G network. Just one touch to share with anyone who matter, such as your customers, staffs and consultants.'
      },
      tab7: {
        tips: 'Solar Power Supply, Operating even on Rainy Days.',
        desc: 'Wiring free and easy-to-assemble, the IP67 Solar Panel has a built-in 7500mAh battery to unleash powerful, eco-friendly energy. IWS3S Weather Station can keep working during rainy weather for 15 consecutive days.',
        details: {
          item1: {
            title: 'Input Voltage',
            value: '5~16V'
          },
          item2: {
            title: 'Output Voltage',
            value: '15V/2A'
          },
          item3: {
            title: 'Battery Capacity',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: 'Solar Panel Power',
            value: '15W'
          },
          item5: {
            title: 'Operating Temperature',
            value: '-20~60℃'
          },
          item6: {
            title: 'IP Rating',
            value: 'IP67'
          },
          item7: {
            title: 'Weight',
            value: '1370g'
          },
          item8: {
            title: 'Dimension',
            value: 'L401*W256*H35.4mm'
          }
        }
      },
      tab9: {
        tips: 'Multi-scenario Applications',
        case1: 'Greenhouse Cultivation',
        case2: 'Cold-chain Logistics',
        case3: 'Food Warehouse Temperature Monitoring',
        case4: 'Horticulture Crop Productin'
      },
      tab10: {
        title: 'Other products that you might be interested in.',
        item1: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IHUB1S Intelligent Box'
        },
        item2: {
          title1: 'XAG',
          title2: '',
          title3: 'IFC13S Farm Camera'
        },
        item3: {
          title1: 'XAG',
          title2: '',
          title3: 'ISM50S Soil Monitor'
        },
        item4: {
          title1: 'XAG',
          title2: '',
          title3: 'IWS7S Weather Station'
        }
      },
      tab11: {
        title: 'Appearance',
        weight: 'Weight  463g'
      },
      details: {
        name: 'Specifications',
        item1: {
          title: 'Voltage',
          value: '5~15V'
        },
        item2: {
          title: 'Power Mode',
          value: 'Solar Panel/USB Charging '
        },
        item4: {
          title: 'IP Rating',
          value: 'IP65'
        },
        item5: {
          title: 'Network Type',
          value: '4G/WiFi/Bluetooth '
        },
        item6: {
          title: 'Positioning',
          value: 'GPS/Base Station '
        },
        item7: {
          title: 'Supporting Carriers',
          value: 'China Mobile / China Unicom / China Telecom / China Telecom SIM Integrated '
        },
        item8: {
          title: 'Temperature Measurement Rang ',
          value: '-20~60℃'
        },
        item9: {
          title: 'Moisture Measurement Range',
          value: '0~100%RH'
        },
        item10: {
          title: 'Illuminance Measurement Range',
          value: '1~125000Lux  '
        },
        item11: {
          title: 'Temperature Accuracy ',
          value: '±0.2℃'
        },
        item12: {
          title: 'Moisture Accuracy ',
          value: '±5% '
        },
        item13: {
          title: 'Illuminance Accuracy',
          value: '±15%  '
        }
      }
    },
    ihub: {
      title1: 'XAG',
      title2: '',
      title3: 'IHUB1S Intelligent Box',
      desc: 'Realize Intelligent Linkage Between Devices',
      tab_nav: {
        item1: 'Introduce',
        item2: 'Specifications'
      },
      tab1: {
        pre_tips: 'RS485 Protocol Interface',
        tips: 'Wired interface, Worry free expansion.',
        desc: 'Through RS485 protocol interface, up to 32 modules can be connected to realize more stable product interconnection',
        details: {
          item1: {
            title: 'RS485',
            value: 'Protocol interface'
          },
          item2: {
            title: '32',
            value: 'Module access'
          }
        }
      },
      tab2: {
        pre_tips: 'Multiple Adding Methods',
        tips: 'Add connections, More possibilities.',
        desc: 'It supports sensing, control and other modules in the industry, and updates the connectable modules in real time with the expansion of the hardware platform. It can be added in a variety of ways to easily connect a variety of modules',
        details: {
          item1: {
            title: 'Auto Mode'
          },
          item2: {
            title: 'Quick Mode'
          },
          item3: {
            title: 'Custom Mode'
          }
        }
      },
      tab3: {
        pre_tips: 'Workflow Mode',
        tips: 'Play with linkage and create automation.',
        desc: 'Connect with XIoT Hub app, easily build automation process and create highly stable and standardized farmland automation scheme'
      },
      tab4: {
        pre_tips: 'Data Management',
        tips: 'Data visualization, Real-time query.',
        desc: 'Through the data collection of various sensors, various types of data are stored in the XIoT Hub app, which supports real-time query and is suitable for agricultural supervision'
      },
      tab11: {
        title: 'Other products that you might be interested in.',
        item1: {
          title1: 'XAG',
          title2: '',
          title3: 'IFC13S Farm Camera'
        },
        item2: {
          title1: 'XAG',
          title2: ' ',
          title3: 'ISM50S Soil Monitor'
        },
        item3: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IWS7S Weather Station'
        },
        item4: {
          title1: 'XAG',
          title2: ' ',
          title3: 'IWS3S Weather Station'
        }
      },
      tab12: {
        title: '',
        weight: ''
      },
      details: {
        name: 'Specifications',
        item1: {
          title: 'Voltage',
          value: 'DC5-15V'
        },
        item2: {
          title: 'Operating Temperature',
          value: '-20~60℃ '
        },
        item3: {
          title: 'Dimensions ',
          value: 'L125*W75*H27mm '
        },
        item4: {
          title: 'Power Mode',
          value: 'Solar Panel/USB Charging'
        },
        item5: {
          title: 'IP Rating',
          value: 'IP66 '
        },
        item6: {
          title: 'Surge level',
          value: '2.0KV '
        },
        item7: {
          title: 'External hardware interface ',
          value: 'RS485/USB'
        },
        item8: {
          title: 'RS485 interface output voltage ',
          value: '12V'
        },
        item9: {
          title: 'RS485 interface communication protocol',
          value: 'modbus-rtu protocol '
        },
        item10: {
          title: 'Number of nodes supported by RS485 interface',
          value: '256 '
        },
        item11: {
          title: 'Network Type',
          value: '4G/WiFi '
        }
      }
    },
    parts: {
      solar: {
        title: 'Solar Power Panel',
        desc1: 'Convenient Power Supply',
        desc2: 'for Outdoors',
        tab1: {
          title: 'Appearance',
          weight: 'Weight 1370g'
        },
        details: {
          name: 'Specifications',
          item1: {
            title: 'Input Voltage',
            value: '5～16V'
          },
          item2: {
            title: 'Output Voltage',
            value: '15V/2A'
          },
          item3: {
            title: 'Battery Capacity',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: 'Solar Panel Power',
            value: '15W'
          },
          item5: {
            title: 'Operational Temperature',
            value: '-20~60℃ '
          },
          item6: {
            title: 'IP Rating ',
            value: 'IP67'
          }
        }
      },
      fixedbanister: {
        title: 'Fixed Pole',
        desc: 'Easy to install and deploy',
        tab1: {
          title: 'Appearance',
          weight: 'Weight 3200g'
        },
        details: {
          name: 'Specifications',
          weight: {
            title: 'Weight',
            value: '5.3KG'
          },
          size: {
            title: 'Dimensions',
            value: '145*145*1200mm'
          }
        }
      },
      bisectwire: {
        title: 'One-divided-two Wire',
        desc: 'One input and two outputs, expand more equipments',
        tab1: {
          title: 'Appearance',
          length: '1.53m'
        },
        details: {
          name: 'Specifications',
          item1: {
            title: 'Operating Voltage',
            value: '5～15V'
          },
          item2: {
            title: 'IP Rating',
            value: 'IP67'
          }
        }
      }
    }
  },
  //  开放平台
  api: {
    name: 'Open Platform',
    desc: 'Provide users with stable, secure and efficient data interfaces, as well as flexible hardware access methods, to meet users personalized business needs.',
    tab1: {
      tips: 'Data Service',
      desc1: 'Based on HTTPS protocol,',
      desc2: 'provide safe and easy-to-use data interface for application'
    },
    tab2: {
      tips: 'Hardware',
      desc: 'Support multiple access methods of RS485, HTTP and SDK.'
    },
    tab3: {
      tips: 'Become a Developer',
      steps1: {
        name: 'Registered account'
      },
      steps2: {
        name: 'Application for authorization'
      },
      steps3: {
        name: 'Complete authorization'
      }
    }
  },
  // 软件
  software: {
    app: {
      title: 'XIoT Hub',
      desc: 'Provide users with simple and quick management',
      btn1: 'APP',
      btn2: 'Applets',
      btn3: 'Web',
      tab1: {
        tips: 'Management equipment',
        desc: 'Scan code to pay attention to quickly understand the running status of the equipment'
      },
      tab2: {
        tips: 'Assist in management',
        desc: 'View crop growth environment data information at any time, set data reminders for effective monitoring'
      },
      tab3: {
        tips: 'Connect user',
        desc: 'Data sharing, product traceability, establishing user and farm connections'
      },
      tab4: {
        tips: 'Smart interconnection',
        desc: 'Scan the QR code on the bottom or right side of the device or go to the “Huawei/Millet App Store” and “Apple App Store” to download and install the “Flying Scarecrow App”.'
      },
      tab5: {
        tips: 'Data management',
        desc: 'More efficient PC-side management tools for enterprise or multi-device users'
      }
    },
    fmadmin: {
      title: 'Data management',
      desc: 'More efficient PC-side management tools for enterprise or multi-device users',
      tab1: {
        tips: 'Equipment batch management',
        desc: 'Visually view device operating status and distribution'
      },
      tab2: {
        tips: 'Device data management',
        desc: 'Can view and download historical data collected within one year'
      }
    }
  },
  // 安装教程
  installs: {
    return: 'Back',
    download: 'Download',
    fm1: {
      name: 'FM1 Installation Tutorial',
      items1: {
        name: 'Fix Solar Panel',
        item1: '1.Insert the matched nuts into the solar panel holder',
        item2: '2.Install the solar panel in the middle of the pole by pushing the holder from the upper half of the pole. The pole notch should be faced the solar panel.',
        item3: '3.Extend the wire on the solar panel to the upper opening of the pole through the notch.',
        item4: '4.Tighten the screws to fix the solar panel.',
        tips: 'Attention: the notch of the pole should be faced the solar panel.'
      },
      items2: {
        name: 'Power On',
        item1: '1.Open the silicone cover on the bottom of the FM1 head, where there is a small white circle button. Please push the button to power it on. When the indicator is light up, the startup has been completed.',
        tips: 'Press the button to turn on FM1 by the hard project which is thinner than the button.'
      },
      items3: {
        name: 'Tighten FM1 Head',
        item1: '1.Connect the FM1 head to the top of the pole',
        item2: '2.Tighten the screws to fix it.'
      },
      items4: {
        name: 'Connect two poles together',
        item1: '1.Connect the two parts of the pole together',
        item2: '2.Tighten the screws to fix them.'
      },
      items5: {
        name: 'Fix the bottom of the Pole',
        item1: '1.Build the cement column.',
        item2: '2.Make the FM1 face the plants.',
        item3: '3.Tighten the screws.'
      },
      pdf: 'FM1 Installation Guide PDF'
    },
    fm2: {
      name: 'FM2 Installation Tutorial',
      items1: {
        name: 'Fixed solar panels',
        item1: '1. Connect the solar panel power cord, and then put the waterproof socket into the riser tube',
        item2: '2.Set the solar panel bracket on the pole. Make sure the gap of the pole is aligned to the direction of the solar panel as shown in the figure, then lock the screws',
        tips: 'Attention: the notch of the pole should be faced the solar panel.'
      },
      items2: {
        name: 'Starting Up',
        item1: '1.Open the small silicone cap on the FM2 head, insert the SIM card, press the movie switch, check the SIM card when the indicator light is always on, then boot completed.If the indicator is flashing, you need to re-check the SIM card',
        tips: 'Press the button to turn on FM2 by the hard project which is thinner than the button.'
      },
      items3: {
        name: 'Install FM2 main body',
        item1: '1.Plug the FM2 main body in the power cord, then set it on the vertical pole and tighten the screws.'
      },
      items4: {
        name: 'Connect two parts of pole',
        item1: '1.Insert the upper half of the pole into the lower half of the pole.',
        item2: '2.Screw up.'
      },
      items5: {
        name: 'Fix the bottom of the pole and adjust the direction of the main body facing toward the sun',
        item1: '1.Driving cement piles.',
        item2: '2.Adjust the direction of FM2 main body, making the logo "XAG" face north.',
        item3: '3.Adjust the direction of solar panel, making it face south. Meanwhile make sure the solar panel tilts downward at an angle of 20-30 degrees.',
        item4: '4.Screw up the nuts on the cement piles and rod chassis.'
      },
      aution1: {
        name: 'Installation Location Requirements',
        item1: '1.The precipitation observation is strongly affected by wind. The device should be installed in an open, flat area, and keep clear of tectonic deformation terrain, strong wind area, trees, constructions, smoke & dust, etc.',
        item2: '2.If the installation location cannot avoid constructions, trees or other obstacles completely, the distance from the device to the obstacle should be twice as much as the altitude difference between them.'
      },
      aution2: {
        name: 'Soil Moisture Sensor Installation Notes',
        item1: '1.The probe should be in close contact with the soil. Do NOT shake the sensor when inserting to the soil.',
        item2: '2.Foreign matters in the soil (e.g. rocks) should be avoided or removed when inserting the probe to prevent damage.',
        item3: '3.The recommended installation method is as follows:'
      },
      autionTips: {
        item1: '1.Dig a hole in the ground',
        item2: '2.Insert into soil from hole section. Please insert the whole sensor in the soil',
        item3: '3.Bury the hole'
      },
      pdf: 'FM2 Installation Guide PDF'
    },
    fc1: {
      name: 'IFC16 Farm Camera Installation Tutorial',
      items1: {
        name: 'Switching On',
        item1: '1.Switch open the rear cover and insert the nano-SIM card accordingly.',
        item2: '2.Press the power button, the indicator will turn on in green, later in orange when the device is on.',
        item3: '3.Close the rear cover tide in case of damage by water in the future.',
        tips: 'Indicator Manual',
        moreInfo: {
          attr1: 'Operation Mode',
          value1: 'Orange',
          attr2: 'Sleeping Mode',
          value2: 'Green',
          attr3: 'Error: Connection failed.',
          value3: 'Slowly Flicking Orange Light',
          attr4: "Error: Can't detect SIM card.",
          value4: 'Fast Flicking Orange Light'
        }
      },
      items2: {
        name: 'Holder Installation',
        item1: '1.Choose the place you want to install and place the holder on the pole accordingly.'
      },
      items3: {
        name: 'Main Device Installation',
        item1: '1.Adjust holder angle, make the camera face towards the subject, then screws tightly.'
      },
      items4: {
        name: 'Wire Connecting and Checking',
        item1: '1.Align the solar panel and the camera rear cover and screw tight, as shown on the left below.',
        item2: '2.Please make sure the silicon part has inserted into the rear cover properly, as shown on the right below.',
        item3: '3.Please make sure rear cover and silicon part are in place, otherwise please tighten them.',
        item4: "4.Please make sure there's no stain on the camera cover and clean the cover regularly.",
        item5: {
          part1: '5.Please check the charging status of the solar panel, if it is shown on WeChat as charging',
          part2: ', then means it’s at normal status.'
        }
      },
      items5: {
        name: 'Introduction of Exterior'
      },
      items6: {
        name: 'List of Items'
      },
      pdf: 'IFC16 Farm Camera Installation Tutorial PDF'
    },
    fc2: {
      name1: 'XAG',
      name: 'IFC16S Farm Camera Installation Tutorial',
      items1: {
        name: 'Install SIM Card',
        item1: '1、Remove the SIM card cover, insert the SIM card into the SIM card slot, and put back the SIM card cover.',
        tips: 'This product has a built-in SIM card, and you can connect to the internet without inserting a SIM card, but you need to activate a data service in the XIoT Hub App.'
      },
      items2: {
        name: 'Mounting Brackets',
        item1: '1、Fix the bracket to the hoop of the pole, and fix it with the 4 screws that come with the hoop. Tighten the screws.'
      },
      items3: {
        name: 'Host Installation',
        item1: '1、Adjust the angle of the bracket, point the camera at the real object, and tighten the screws.',
        item2: '2、Plug one end of the power cable into the host power connector, and the other end to the solar panel output connector.'
      },
      items4: {
        name: 'Power On',
        item1: '1、Press the power button, the three lights will turn on in the order of the power light (1) -> status light (2) -> signal light (3), then all three lights are turned on, which means startup completed.',
        tips: {
          name: 'Indicator description',
          item1: 'Light is always on',
          item2: 'Light is flashing',
          item3: 'Light off'
        },
        moreInfo: {
          attr1: 'Mode',
          value1: 'Blue light',
          method1: '',
          attr2: 'Sleep or standby mode',
          value2: 'Light off',
          method2: 'Press the power button to resume working mode',
          attr3: 'Error: SIM card not detected',
          value3: 'The status light flashing',
          method3: 'Check if the SIM card is valid and installed correctly',
          attr4: 'Error: Internet connectin failed',
          value4: 'Signal indicator flashing',
          method4: 'Check if the device location is within the coverage of the carrier signal and restart the sensor device'
        },
        item2: '2、Check for stains on the front lens hood and clean it regularly.',
        item3: '3、Check whether the device is fixed, the screws must be tightened, and the device cannot shake.',
        item4: {
          part1: '4. Check the charging status of the solar panel to see if the charging lamp on the back of the solar panel is on. You can also scan the QR code on the homepage to enter the Little Program named “XIoT Hub", and the (lightning) symbol is displayed to indicate normal charging.'
        }
      },
      pdf: 'IFC16S Farm Camera Installation Tutorial PDF'
    },
    sm: {
      name1: 'XAG',
      name: 'ISM50 Soil Monitor Installation Tutorial',
      items1: {
        name: 'Install SIM Card',
        item1: '1、Use an L-shaped wrench to loosen the screws on both sides of the SIM card cover,  remove the card cover, insert the SIM card, then put back the card cover and tighten the screws.',
        tips: 'This product has a built-in SIM card, and you can connect to the internet without inserting a SIM card, but you need to activate a data service in the XIoT Hub App.'
      },
      items2: {
        name: 'Install Device',
        item1: '1、Connect the solar panel and sensor device using the included power cable. Plug one end of the power cable into the power connector of the host and the other end to the power output connector of the solar panel.',
        item2: '2、Use a shovel to dig a pit in the ground at the selected location, and bury the sensor device in the pit and ensure that the ground line on the device is flush with the ground.'
      },
      items3: {
        name: 'Power On',
        item1: '1、Press the power button, the three lights will turn on in the order of the power light (1) -> status light (2) -> signal light (3), then all three lights are turned on, which means startup completed.',
        tips: {
          name: 'Indicator description',
          item1: 'Light is always on',
          item2: 'Light is flashing',
          item3: 'Light off'
        },
        moreInfo: {
          attr1: 'Mode',
          value1: 'Blue light',
          method1: '',
          attr2: 'Sleep or standby mode',
          value2: 'Light off',
          method2: 'Press the power button to resume working mode',
          attr3: 'Error: SIM card not detected',
          value3: 'The status light flashing',
          method3: 'Check if the SIM card is valid and installed correctly',
          attr4: 'Error: Internet connectin failed',
          value4: 'Signal indicator flashing',
          method4: 'Check if the device location is within the coverage of the carrier signal and restart the sensor device'
        },
        item2: '2、Check whether the sensor device is properly landfilled. The ground line of the device needs to be flush with the ground.',
        item3: '3、Check whether the device is fixed, the device must be landfilled tightly, and the device cannot shake.',
        item4: '4、Check whether the power connection cable is loose. Plug it in tightly.',
        item5: {
          part1: '5、Check the charging status of the solar panel to see if the charging lamp on the back of the solar panel is on. You can also scan the QR code on the homepage to enter the “XIoT Hub" mini program, and the ',
          part2: 'symbol is displayed to indicate normal charging.'
        }
      },
      pdf: 'ISM50 Soil Monitor Installation Tutorial PDF'
    },
    ws: {
      name1: 'XAG',
      name: 'IWS7 Weather Station Installation Tutorial',
      items1: {
        name: 'Install SIM Card',
        item1: '1、Use an L-shaped wrench to loosen the screws on both sides of the SIM card cover, remove the card cover, insert the SIM card, then put back the card cover and tighten the screws.',
        tips: 'This product has a built-in SIM card, and you can connect to the internet without inserting a SIM card, but you need to activate a data service in the XIoT Hub App.'
      },
      items2: {
        name: 'Mounting Brackets ',
        item1: '1、Fix the bracket to the hoop of the pole, and fix it with the 4 screws that come with the hoop. Tighten the screws.',
        item2: '2、Pass the power cable through the bracket as shown below.'
      },
      items3: {
        name: 'Wiring and Fixing',
        item1: '1、Plug one end of the power cable into the power connector of the host and the other end to the power output connector of the solar panel, as shown in the figure below.',
        item2: '2、Install the sensor device on the bracket and use the L-shaped wrench to tighten the 1 screw provided.'
      },
      items4: {
        name: 'Power On',
        item1: '1、Press the power button, the three lights will turn on in the order of the power light (1) -> status light (2) -> signal light (3), then all three lights are turned on, which means startup completed.',
        tips: {
          name: 'Indicator description',
          item1: 'Light is always on',
          item2: 'Light is flashing',
          item3: 'Light off'
        },
        moreInfo: {
          attr1: 'Mode',
          value1: 'Blue light',
          method1: '',
          attr2: 'Sleep or standby mode',
          value2: 'Light off',
          method2: 'Press the power button to resume working mode',
          attr3: 'Error: SIM card not detected',
          value3: 'The status light flashing',
          method3: 'Check if the SIM card is valid and installed correctly',
          attr4: 'Error: Internet connectin failed',
          value4: 'Signal indicator flashing',
          method4: 'Check if the device location is within the coverage of the carrier signal and restart the sensor device'
        },
        item2: '2、Check whether the power connection cable is loose. Plug it in tightly.',
        item3: '3、Check whether the power connection cable is loose. Plug it in tightly.',
        item4: {
          part1: '4、Check the charging status of the solar panel to see if the charging lamp on the back of the olar panel is on. You can also scan the QR code on the homepage to enter the “XIoT Hub" mini program, and the ',
          part2: 'symbol is displayed to indicate normal charging.'
        }
      },
      pdf: 'IWS7 Weather Station Installation Tutorial PDF'
    },
    ht: {
      name1: 'XAG',
      name: 'IWS3 Weather Station Installation Tutorial',
      items1: {
        name: 'Install SIM Card',
        item1: '1、Use an L-shaped wrench to loosen the screws on both sides of the SIM card cover, remove the card cover, insert the SIM card, then put back the card cover and tighten the screws.',
        tips: 'This product has a built-in SIM card, and you can connect to the internet without inserting a SIM card, but you need to activate a data service in the XIoT Hub App.'
      },
      items2: {
        name: 'Mounting Brackets',
        item1: '1、Fix the bracket to the hoop of the pole, and fix it with the 4 screws that come with the hoop. Tighten the screws.',
        item2: '2、Pass the power cable through the bracket as shown below.'
      },
      items3: {
        name: 'Wiring and Fixing',
        item1: '1、Plug one end of the power cable into the power connector of the host and the other end to the power output connector of the solar panel, as shown in the figure below.',
        item2: '2、Install the sensor device on the bracket and use the L-shaped wrench to tighten the 1 screw provided.'
      },
      items4: {
        name: 'Power On',
        item1: '1、Press the power button, the three lights will turn on in the order of the power light (1) -> status light (2) -> signal light (3), then all three lights are turned on, which means startup completed.。',
        tips: {
          name: 'Indicator description',
          item1: 'Light is always on',
          item2: 'Light is flashing',
          item3: 'Light off'
        },
        moreInfo: {
          attr1: 'Mode',
          value1: 'Blue light',
          method1: '',
          attr2: 'Sleep or standby mode',
          value2: 'Light off',
          method2: 'Press the power button to resume working mode',
          attr3: 'Error: SIM card not detected',
          value3: 'The status light flashing',
          method3: 'Check if the SIM card is valid and installed correctly',
          attr4: 'Error: Internet connectin failed',
          value4: 'Signal indicator flashing',
          method4: 'Check if the device location is within the coverage of the carrier signal and restart the sensor device'
        },
        item2: '2、Check whether the power connection cable is loose. Plug it in tightly.',
        item3: '3、Check whether the device is fixed, the screws must be tightened, and the device cannot shake.',
        item4: {
          part1: '4、Check the charging status of the solar panel to see if the charging lamp on the back of the solar panel is on. You can also scan the QR code on the homepage to enter the “XIoT Hub" mini program, and the',
          part2: 'symbol is displayed to indicate normal charging.'
        }
      },
      pdf: 'IWS3 Weather Station Installation Tutorial PDF'
    },
    solar: {
      name: 'Solar Power Panel Installation Tutorial',
      items1: {
        name: 'Install Solar Charging Board',
        item1: '1、Put the bracket into the bracket mounting groove of the solar panel, and use the L-shaped wrench to tighten the 4 M3 screws.',
        item2: '2、Unscrew the 4 screws of the pipe clamp fixed on the pole in advance, and then install the solar panel with the bracket on the pipe clamp so that the 4 screw holes on the bracket are aligned with the screw holes on the pipe clamp. Insert the removed 4 screws and tighten them with an L-shaped wrench.',
        item3: '3、Adjust the direction of the solar panel. Loosen the pipe clamp fixing screws and rotate the solar panel. Tighten the pipe clamp fixing screws after the solar panel is facing south (north hemisphere). Loosen the solar panel fixing screws, turn the solar panel to tilt it towards the ground at an angle of 20-30°, and then tighten the solar panel fixing screws.',
        tips: 'When fixing the solar panel bracket, the solar panel needs to face upward.'
      },
      pdf: 'Solar Power Panel Installation Tutorial PDF'
    },
    // 配件
    accessories: {
      name: 'List of Items',
      item1: 'Allen key1',
      item2: 'Allen key2',
      item3: 'Open-ended wrench',
      item4: 'M6*8 hexagonal socket head cap screws',
      item5: 'M6*10Hexagon socket countersunk head screws',
      item6: 'Inner expansion screw',
      item_1: 'Hexagonal opposite side 4*29*74(1)',
      item_2: 'Hexagonal opposite side 5*30*80(1)',
      item_3: 'Hexagonal opposite side 13*8*2(1)',
      item_4: 'M6*8(3)',
      item_5: 'M6*10(4)',
      item_6: 'M10*L100(4)'
    },
    // 户外立杆安装
    fixedpole: {
      name: 'Fixed Pole Outdoor Installation Tutorial',
      items1: {
        name: '户外环境 一： 安装在水泥地面',
        item1: '1、制作底座（用 DN32 镀锌管，壁厚 3.5mm 与一块 210*210mm 方块焊接），如下图一所示，详细图纸请参考附件 1；',
        item2: '2、在水泥地面上安装底座，钻孔埋入 4 个 M6*80 膨胀螺丝，将以上底座安装上去，如下图二所示；',
        item3: '3、将立杆套进底座内，在立杆底部锁两颗 M6 螺丝固定。如下图三所示.'
      },
      items2: {
        name: '户外环境二：安装在 水田',
        item1: '1、制作水泥桩，中心预留立杆孔（直径 35mm，深 300mm），如下图四所示；',
        item2: '2、将水泥桩埋于土壤内，掩埋水泥桩，使其稳固，如下图五所示；',
        item3: '3、将主机立杆插入水泥桩内，再用泥图掩埋，如下图六所示；'
      },
      items3: {
        name: '户外环境三 ：安装在山地',
        item1: '1、制作底座（用 DN32 镀锌管，壁厚 3.5mm 与一块 210*210mm 方块焊接），如下图七所示，图纸请参考附件 2；',
        item2: '2、将带有底座的立杆埋在土壤底下约 400mm，具体深度依据土质决定，如下图八所示。',
        item3: '3、并将立杆套进底座内，在立杆底部锁两颗 M6 螺丝固定。如下图九所示；'
      },
      pdf: '物联产品立杆户外安装方式'
    }
  },
  // 产品指南
  guide: {
    title: 'Product Guide',
    desc: 'Help you use products better',
    installs: {
      item1: 'IFC16S Farm Camera Installation Tutorial',
      item2: 'ISM50 Soil Monitor Installation Tutorial',
      item3: 'IWS7 Weather Station Installation Tutorial',
      item4: 'IWS3 Weather Station Installation Tutorial',
      item5: 'IFC16 Farm Camera Installation Tutorial',
      item6: 'FM2 Installation Tutorial',
      item7: 'FM1 Installation Tutorial',
      item8: 'Solar Power Panel Installation Tutorial',
      item9: 'XIoT Fixed Pole Outdoor Installation Tutorial'
    },
    more: 'More'
  },
  // 问答
  questions: {
    name: 'Help Center',
    desc: 'Answer all your questions',
    faq: 'FAQ',
    item1: {
      q: 'Click "my device" will not be able to enter Mini Programs?',
      a: 'Because previous versions of WeChat do not support Mini Programs, so please update WeChat to the latest version.'
    },
    item2: {
      q: 'Can`t connect to the network after the device is turned on?',
      a: 'Check the device indicator after booting. If the green light always flashes, then the device has not detected the SIM card. Please check that the SIM card is installed correctly.'
    },
    item3: {
      q: 'Why the equipment name cannot be changed in Mini Programs?',
      a: 'Only the equipment manager can change the equipment name.'
    },
    item4: {
      q: 'How to become an equipment Manager?',
      a: 'If the equipment has not been used, the first user to scan and add the equipment will become the equipment manager; if the equipment already has a manager, the current equipment manager will be required to remove the device. The new user then will become the manager after re-scanning and adding the equipment.'
    },
    item5: {
      q: 'Why the image is blurred?',
      a: 'The blurring of the image was caused by camera focus failure due to the strong ambient light. The solution is to install the equipment in which there is no direct sunlight exposure. Moreover, lower the image brightness parameters.'
    },
    item6: {
      q: 'Why the “all-day video” shakes?',
      a: 'With default parameters, the equipment may be affected by ambient light or scenery to cause a change in the image taken at some point in time. So after the installation of the equipment, please set the splice mode as “Maintain”.'
    },
    item7: {
      q: 'Why the equipment gets offline after a period of work?',
      a1: 'There are two main reasons：',
      a2: '1.The signal of the installation area is unstable. So please move the equipment to a signal-stabilized area.',
      a3: '2.The equipment battery is dead, usually due to the improper installation of solar panels. Please adjust the solar panels toward the south and increase the solar exposure time to achieve maximum conversion efficiency.'
    }
  },
  // 售后服务
  afterMarket: {
    name: 'After-sale Maintenance',
    desc: 'Provide reliable services for you',
    flow: {
      name: 'Flow',
      step1: {
        step: '01',
        title: 'Sign up',
        desc: 'Enter the WeChat Mini Program "极飞服务" to sign up a account'
      },
      step2: {
        step: '02',
        title: 'Trouble shooting',
        desc: 'Select "Fault Repair Portal"'
      },
      step3: {
        step: '03',
        title: 'Fill in the information',
        desc: 'Fill in the device information and troubles'
      },
      step4: {
        step: '04',
        title: 'Complete',
        desc: 'Wait until the completion is complete, staff feedback'
      }
    },
    info: {
      name: 'After-sale Maintenance',
      staff: 'Staff:',
      staffName: '景代敏',
      address: '东莞大岭山连平村莞长路力桑工业园 极飞科技',
      express: 'After-sales tel',
      tel: '18925499895'
    },
    moreInfo: 'See more',
    document: 'After-sale agreement'
  },
  // 文档下载
  download: {
    name: 'Document download',
    faq: 'Equipment installation and software use',
    products: {
      name: 'Introduction',
      fc2: 'IFC16S Farm Camera Introduction',
      sm: 'ISM50 Soil Monitor Introduction',
      ws: 'IWS7 Weather Station Introduction',
      ht: 'IWS3 Weather Station Introduction',
      fc1: 'IFC16 Farm Camera Introduction',
      fm1: 'FM1 Introduction',
      fm2: 'FM2 Introduction'
    },
    install: {
      name: 'Installation Guide',
      fc2: 'IFC16S Farm Camera Installation Guide',
      sm: 'ISM50 Soil Monitor Installation Guide',
      ws: 'IWS7 Weather Station Installation Guide',
      ht: 'IWS3 Weather Station Installation Guide',
      solar: 'Solar Power Panel Installation Guide',
      fc1: 'IFC16 Farm Camera Installation Guide',
      fm1: 'FM1 Installation Guide',
      fm2: 'FM2 Installation Guide',
      fixedpole: 'Fixed Pole Outdoor Installation Tutorial Guide'
    },
    specifications: {
      name: 'Specifications',
      ihub1s: 'IHUB1S Intelligent Box Specifications',
      ifc13s: 'IFC13S Farm Camera Specifications',
      iws3s: 'IWS3S Weather Station Specifications',
      iws7s: 'IWS7S Weather Station Specifications',
      ism50s: 'ISM50S Soil Monitor Specifications',
      itl: 'ITL Specifications',
      itlpro: 'ITL Pro Specifications',
      fc2: 'IFC16S Farm Camera Specifications',
      sm: 'ISM50 Soil Monitor Specifications',
      ws: 'IWS7 Weather Station Specifications',
      ht: 'IWS3 Weather Station Specifications',
      solar: 'Solar Power Panel Specifications'
    },
    btn: 'download'
  },
  footer: {
    copyright: 'XAG Co., Ltd. All Rights Reserved.',
    miit: '(粤ICP备13085628号)' // 备案
  },
  // 页面建设中
  building: {
    title: 'The page is updating',
    desc: 'coming soon',
    back: 'Back Home'
  },
  // 404页面
  pageUndefinded: {
    title: '404',
    desc: 'The page you visited is not exist'
  },
  filter: {
    hour: 'hour',
    minute: 'minute',
    second: 'second',
    rightNow: 'Just Now',
    minuteAgo: 'Mins Ago',
    today: 'Today',
    yesterday: 'Yesterday'
  },
  components: {
    sliderDefault: 'Drag the slider to the right',
    sliderIsEnd: 'Verification complete',
    inputGroupPasteError: 'Only numbers are supported'
  },
  // 登录页 sign in
  signin: {
    backToIndex: 'Back To Index',
    account: 'Accout',
    tel: 'Telephone',
    wechat: 'Wehcat',
    thirdMethod: 'Other Methods',
    wechatThirdMethod: 'Wehcat',
    accountPlaceholder: 'account/email/telephone',
    pswPlaceholder: 'password',
    telPlaceholder: 'telephone',
    areaCodePlaceholder: 'Select',
    getVcodeText: 'Get Code',
    getVcodeTextLater: 'Resend({ticker}s) ',
    verificationCodePlaceholder: 'verification code',
    accountLoginError: 'Wrong account or password',
    telLoginError: 'Wrong telephone or verification code',
    signin: 'Sign in',
    forgetPsw: 'Forgot Password',
    registerAccount: 'Sign Up',
    loginAgreeTips: 'Sign in and agree',
    userService: '《User Service Agreement》',
    userPrivate: '《Privacy Policy》',
    // 字段验证 规则错误
    accountEmptyError: 'Please input the account',
    pswEmptyError: 'Please input password',
    telEmptyError: 'Please input telephone',
    VcodeEmptyError: 'Please input the verification code',
    telFormatError: 'Please input the correct telephone'
  },
  // signup 注册页
  signup: {
    applyAccount: 'Apply account',
    hasAccount: 'Already own an account',
    toLogin: 'Sign in',
    exitApply: 'Exit',
    // 注册
    accountPlaceholder: 'account',
    accountFormatTips: '6-24 digits, letter combination',
    accountEmptyError: 'Please input your user name',
    accountExistError: 'The user name is already in use, please input another one',
    accountFormatError: 'The user name is a combination of 6-24 digits and letters, and cannot be a pure number',
    pswPlaceholder: 'password',
    pswFormatTips: '8-24 digits of numbers, letters or common symbols',
    pswFormatError: 'Password input format error, please re-enter',
    pswEmptyError: 'Password cannot be empty',
    pswConfirmPlaceholder: 'confirm password',
    pswConfirmError: 'The two passwords are inconsistent, please re-enter',
    emailPlaceholder: 'email',
    emailEmptyError: 'Email cannot be empty',
    emailFormatError: 'Email input format error, please re-enter',
    emailExistError: 'The email is already in use, please re-enter',
    accpetPrivacyTips1: 'I have read and accepted',
    accpetPrivacyTips2: '《Privacy Terms》',
    accpetPrivacyError: 'Please read and accepted to the 《Privacy Terms》',
    toRegister: 'Apply Now',
    emailSendedTitle: 'Verify identity, complete the registration',
    emailSendedTips1: 'The verification code has been sent to the email {email}, please check it and fill it in below',
    emailSendedToEmail: 'Sign in the mail',
    emailSendedNoRecicve: 'Not received? ',
    emailSendedResend: 'Resend',
    toActive: 'Comfirm'
  },
  // forgetPsw 忘记密码
  forgetPsw: {
    getBackPasswordTitle: 'Retrieve password',
    rememberPassword: 'Remember the password, ',
    toLogin: 'Sign in',
    toUser: 'Back',
    accountPlaceholder: 'account/email/telephone',
    accountEmptyError: 'Please input account/email/telephone',
    nextBtn: 'Next',
    vcodeSendedTitle: 'Verify identity, retrieve password',
    vcodeSendedTips1: 'The verification code has sent to the ',
    vcodeSendedTips2: '.Please pay attention to receive and fill in the blank below. ',
    telVerify: 'telephone ',
    emailVerify: 'email ',
    vcodeSendedNoRecicve: 'Not received? ',
    vcodeSendedResend: 'Resend',
    // 重置密码
    resetPswTitle: 'Reset password',
    pswPlaceholder: 'password',
    pswFormatTips: ' 8-24 digits of numbers, letters or common symbols',
    pswEmptyError: 'Password cannot be empty',
    pswFormatError: 'Wrong password format, please input again',
    pswConfirmPlaceholder: 'confirm password',
    pswConfirmError: 'The two passwords are inconsistent, please re-enter',
    reserBtn: 'Comfirm'
  },
  // 账号注销页
  delete: {
    back: 'Back',
    out: 'Logout',
    deleteTitle: 'Delete Account',
    deleteTipsTitle: 'You are applying for deletion of XIoT account',
    deleteTipsDesc: 'The account cannot be recovered after deletion. Please operate with caution. After the deletion is successful, all your personal data, information and rights on XIoT Hub will be cleared and cannot be retrieved, including but not limited to the following contents:',
    deleteTipsLine1: '1. Your account space storage will be cleared;',
    deleteTipsLine2: '2. Your vouchers will be cleared;',
    deleteTipsLine3: '3. Your orders will be cleared and cannot be invoiced;',
    deleteTipsLine4: '4. Your module list on hardware platform  will be cleared;',
    deleteDeleteBtn: 'Got it, confirm to delete',
    deleteSuccessTitle: 'Account deletion application completed',
    deleteSuccessDesc: 'The account will be automatically deleted after 15 days, and all data will be cleared. Please do not log in during this time period to ensure that the deletion is completed successfully.'
  },
  // 社区
  community: {
    // 社区主页
    index: {
      emptyPost: 'No Post',
      allPost: 'All Posts',
      newPost: 'New Post',
      searchPostPlaceholder: 'Please input search content',
      searchPostResult: 'Search result: find {num} posts related to <span style="color:#4580fe">“{key}”</span>',
      pageGo: 'Go',
      lastModifiled: 'Last Edited At',
      deletedAccount: 'Deleted Account',
      adminLabel: 'Admin',
      needLogin: 'Need sign in to operate',
      loginEnter: 'Go Sign in',
      loginCancel: 'Cancel',
      searchCancel: 'Cancel',
      fetchMore: 'Load More',
      emptyPostNew: 'No Content'
    },
    // 帖子详情页
    detail: {
      deletedAccount: 'Deleted Account',
      emptyPost: 'Post does not exist',
      deletePostBtn: 'Delete Post',
      editPostBtn: 'Edit Post',
      lastModifiled: 'Last Edited At',
      adminLabel: 'Admin',
      viewIconText: 'view', // 浏览图标
      CommentIconText: 'comment', // 评论图标
      CommentNum: 'comments', // 评论数量
      writeCommentBtn: 'Write Comment',
      deleteCommentBtn: 'Delete Comment',
      doWriteComment: 'Do Write Comment',
      writeReplyBtn: 'Write Reply',
      deleteReplyBtn: 'Delete Reply',
      // 回复的文本编辑器
      reply: 'Reply to',
      hideReplyBox: 'Hide Reply Box',
      doWriteReply: 'Do write reply',
      deleteTitle: 'Delete',
      confirmDelete: 'Are you sure to delete？',
      deleteReason: 'Delete reason',
      selectDeleteReason: 'Please choose the delete reason',
      deleteReason1: 'Ad info',
      deleteReason2: 'Illegal info',
      deleteReason3: 'Unfirendly info',
      deleteCancel: 'Cancel',
      deleteEnter: 'Sure',
      loginTips: 'Tips',
      needLogin: 'Need Sign in to operate',
      loginEnter: 'Sign in',
      loginCancel: 'Cancel'
    },
    // 帖子编辑页
    edit: {
      postTitle: 'Post Title',
      postTitlePlaceholder: 'The length of the post title can not over 30',
      postTitleError: 'Post title is empty',
      postContent: 'Post Content',
      postContentError: 'Post content is empty',
      saveBtn: 'Update',
      cancelBtn: 'Cancel',
      confirmCancelEdit: 'Are you sure to give up to update the post?',
      confirmEnter: 'Confirm',
      confirmCancel: 'Cancel'
    },
    // 发布新帖子
    new: {
      postTitle: 'Post Title',
      postTitlePlaceholder: 'The length of the post title can not over 30',
      postTitleError: 'Post title is empty',
      postContent: 'Post Content',
      postContentError: 'Post content is empty',
      saveBtn: 'Publish'
    },
    // 我的主页
    userHome: {
      deletedAccount: 'Deleted Account',
      post: 'Posts',
      tab1: 'Post',
      tab2: 'Dynamic',
      emptyPost: 'No Post',
      lastModifiled: 'Last Edited At',
      deleteBtn: 'Delete',
      emptyDynamic: 'No Dynamic',
      hasReplied: 'has replied',
      yourPost: 'Your post',
      youInPost: 'Your comment in the post',
      commentInPost: '',
      hasBeenDeleted: 'has been deleted by Admin',
      deleteReason: 'delete reason',
      confirmDelete: 'Are you sure to delete?',
      confirmEnter: 'Confirm',
      confirmCancel: 'Cancel'
    }
  },
  // 个人中心
  self: {
    // 首页
    index: {
      title: 'User Center',
      user: 'User Info',
      authAccount: 'Auth Account',
      notice: 'Notice'
    },
    // 用户信息
    user: {
      nickname: 'nickname',
      account: 'account',
      password: 'password',
      email: 'email',
      tel: 'tel',
      wechat: 'wechat',
      unbinded: 'Unbinded',
      seted: 'Set',
      unset: 'Not Set',
      set: 'Set',
      edit: 'Edit',
      change: 'Change',
      delete: 'Delete',
      wechatTips: 'To unbind the third-party account, you need to bind the mobile phone number first to ensure the security of the account',
      // 验证码
      validCodePlaceholder: 'Input Verification Code',
      validCodeSend: 'Get Code',
      validCodeSendAgain: 'Resend',
      // 发送邮箱
      emailNoRecived: 'No Received?',
      emailSendAgain: 'Resend',
      // 修改昵称相关
      nicknameSetTitle: 'Set nickname',
      nicknameEditFormNicknamePlaceholder: 'nickname',
      nicknameFormNicknameRule: 'Input 2-24 chinese、letter、number、support -_ symbols',
      nicknameEditBtn: 'Confirm',
      nicknameEditCancel: 'Cancel',
      // 修改密码相关
      pswSetTitle: 'Set Password',
      pswEditTitle: 'Edit Password',
      pswOldPasswordPlaceholder: 'original password',
      pswEditToAuthTitle: 'Verify identity',
      pswEditToAuthTips: 'To protect the security of the account, you need to verify the current password first, and then proceed to the next step after successful verification',
      pswEditToAuthForgot: 'Forgot',
      pswNewPasswordPlaceholder: 'new password',
      pswConfirmPasswordPlaceholder: 'confirmation password',
      pswPasswordRule: '8-24 digits of numbers, letters or common symbols',
      pswEditNextBtn: 'Next',
      pswEditBtn: 'Confirm',
      pswEditCancel: 'Cancel',
      // 绑定、修改邮箱相关
      emailSetTitle: 'Set Email',
      emailEditTitle: 'Change Email',
      emailDeleteTitle: 'Delete Email',
      // 修改邮箱前验证
      emailEditToAuthTitle: 'Verify identity, change email',
      emailEditToAuthTips: 'To protect account security, you need to verify the current mailbox first, and then proceed to the next step after successful verification',
      emailEditToAuthNextBtn: 'Next',
      // 填写新邮箱
      emailEditFormEmailPlaceholder: 'Input your email',
      emailEditNewEmailTitle: 'Verify identity, complete replacement',
      emailEditNewEmailTips: 'The verification code has been sent to email {email}. Please check it and fill it in below',
      emailEditBtn: 'Edit',
      // 解除绑定
      emailDeleteConfirmTitle: 'Confirm unbinding',
      emailDeleteConfirmTips: 'Unbound, you will no longer be able to log in to XIoT Hub with this email as your account',
      emailDeleteConfirmEnter: 'Confirm',
      emailDeleteConfirmCancel: 'Back',
      emailDeleteToAuthTitle: 'Verify identity, unbind email',
      emailDeleteToAuthTips: 'The verification code has been sent to email {email}. Please check it and fill it in below',
      emailDeleteBtn: 'Confirm',
      // 绑定，修改手机相关
      telSetTitle: 'Set Telephone',
      telEditTitle: 'Change Telephone',
      telDeleteTitle: 'Delete Telephone',
      // 原手机验证
      telEditToAuthTitle: 'Verify identity, change telephone',
      telEditToAuthTips: 'To protect account security, you need to verify the current telephone first, and then proceed to the next step after successful verification',
      telEditNextBtn: 'Next',
      telEditFormTelPlaceholder: 'Input your telephone',
      telEditBtn: 'Confirm',
      // 解除绑定手机
      telDeleteConfirmTitle: 'Confirm unbinding',
      telDeleteConfirmTips: 'Unbound, you will no longer be able to log in to XIoT Hub with this telephone number as your account',
      telDeleteConfirmEnter: 'Confirm',
      telDeleteConfirmCancel: 'Back',
      telDeleteToAuthTitle: 'Verify identity, unbind telephone',
      telDeleteToAuthTips: 'The verification code has been sent to telephone {tel}. Please check it and fill it in below',
      telDeleteBtn: 'Confirm',
      // 绑定、修改微信相关
      wechatSetTitle: 'Set Wechat',
      wechatDeleteTitle: 'Delete Wechat',
      wechatEditTitle: 'complete the verification, set your new wechat',
      wechatEditTips: 'Use the wechat you want to bind to scan the  QRCode above',
      // 解除绑定微信
      wechatDeleteConfirmTitle: 'Confirm unbinding',
      wechatDeleteConfirmTips: 'Unbound, you will no longer be able to log in to XIoT Hub with this wechat as your account',
      wechatDeleteConfirmEnter: 'Confirm',
      wechatDeleteConfirmCancel: 'Cancel',
      wechatEditToDeleteTips: 'Use the current wechat to scan the QRCode above to delete wehcat',
      // 字段验证 规则错误
      nicknameFormatError: 'Nickname format：2-24 chinese、letter、number、support -_ symbols',
      pswFormatError: 'Wrong Password Format, Please Input Again',
      pswEmptyError: 'Password Cannot Be Empty',
      oldPswEmptyError: 'Original Password Cannot Be Empty',
      pswConfirmError: 'Password and confirm password do not match，please input agagin',
      emailEmptyError: 'Please input the email',
      emailSameError: 'original email is the same with your new email',
      emailFormatError: 'Wrong email Format, Please Input Again',
      validCodeEmptyError: 'Please input the verification vcode',
      validCodeError: 'Wrong verification code',
      telEmptyError: 'Please input your new telephone',
      telSameError: 'original telephone is the same with your new telephone',
      telFormatError: 'Please input the right format telephone',
      validCodeImgEmptyError: 'Input Verification Code At Right',
      // 注销账号
      deleteAccount: 'Delete Account'
    },
    // 授权账号
    authAccount: {
      addAuthAccountBtn: 'Add Account',
      authAccountEmpty: 'Auth Account Empty',
      nicknameAndAccount: 'Nickname（Account）',
      authority: 'Authority',
      authorityReadOnly: 'Read',
      authorityReadWrite: 'Read & Write',
      operation: 'Operation',
      operationEdit: 'Edit',
      operationDelete: 'Delete',
      // 添加账号
      addSubAccountTitle: 'Add Account',
      subAccountTypePerson: 'User',
      subAccountTypePlaform: 'Platform',
      subAccountInput: 'Add Account',
      subAccountInputPlaceholder: 'Input the auth account',
      subAccountInputEmptyError: 'Please input the auth account',
      subAccountInputFormatError: 'Please input the correct account',
      subAccountSelectPlaceholder: 'Select the platform account',
      subAccountSelectEmptyError: 'Please select the platform account',
      subAccountExistError: 'The account has been added',
      subAccountBack: 'Back',
      subAccountAddBtn: 'Add',
      subAccountOverLimit: 'Up to {max} auth accounts can be added, up to the limit', // 授权账号个数超出限制提示
      // 删除授权账号
      subAccountDeleteConfirmTitle: 'Delete',
      subAccountDeleteConfirm: 'Are you sure to delete the auth account ?',
      subAccountDeleteConfirmEnter: 'Confirm',
      subAccountDeleteConfirmCancel: 'Cancel',
      // 添加设备
      addDevicesTitlePerson: 'User',
      addDevicesTitleStep1: 'Add Devices >>',
      addDevicesTitleStep2: 'Authority Edit',
      devicesEmpty: 'Owned Device Empty',
      deviceName: 'Device Name',
      addDevicesBack: 'Back',
      addDevicesAddBtn: 'Add',
      addDevicesSkip: 'Skip',
      addDevicesNext: 'Next',
      addDevicesPrevious: 'Previous',
      addDevicesEnter: 'Confirm',
      addDevicesSelectionsEmpty: 'No devices selected',
      // 权限管理
      authEditTitle: 'Authority Edit',
      authDevicesEmpty: 'Authed Devices Empty',
      authDevicesToAddDevices: 'Add Devices',
      authDevicesCheckAll: 'Check All',
      authDevicesDelete: 'Delete',
      authEditCancel: 'Cancel',
      authEditSaveBtn: 'Save',
      authEditNoUpdate: 'No content to update',
      // 正在操作提示框
      progressTitleDefault: 'Operating',
      progressContentDefault: '',
      progressTitleComplete: 'Operation Tips',
      progressContentSuccess: 'success',
      progressContentFail: 'fail'
    },
    // 通知
    notice: {
      setAllRead: 'Mark All As Read',
      setRead: 'Mark As Read',
      noticeEmpty: 'Notice Empty',
      newLabel: 'New'
    }
  },
  // 平台
  platform: {
    index: { // 首页菜单
      title: 'Platform Center',
      platformAccess: 'Platform Access',
      platformInfo: 'Platform Information',
      softwarePlatform: 'Software Platform',
      softwareSetting: 'Basic Configuration',
      softwareTools: 'Utilities',
      softwareAPI: 'API',
      // 这里一大部分的api相关
      introduction: 'Introduction',
      docLi0: 'Service endpoint',
      docLi1: 'Authentication',
      docLi2: 'Interface Summarization',
      api: 'Interfaces',
      docLi3: '1.1 login',
      docLi4: '1.2 logout',
      docLi5: '1.3 list authorized accounts',
      docLi6: '2.1 modify device',
      docLi7: '2.2 get device',
      docLi8: '2.3 list devices',
      docLi9: '2.4 subscribe device',
      docLi10: '2.5 unsubscribe device',
      docLi11: '3.1 get datapoints',
      docLi12: '3.2 get last datapoint',
      docLi13: '4.1 get live streaming url',
      docLi14: '5.1 get annual accumulated temperature',
      docLi15: '5.2 get monthly rainfall',
      docLi16: '5.3 get other daily statistics',
      docLi17: '5.4 get device cellular data(obsolete)',
      docLi18: '5.5 get device cellular data',
      docLi19: '6.1 massages',
      docLi20: '7.1 Buy cellular data with XAG coins',
      docLi21: '7.2 get user XAG coins',
      messages: 'messages appendix',
      docLi22: 'device online/offline messages',
      docLi23: 'datapoints messages',
      datapoints: 'datapoints appendix',
      docLi24: 'FM1',
      docLi25: 'FM2',
      docLi26: 'ITL Pro(RTK)',
      docLi27: 'ITL(GPS)',
      docLi28: 'IFC16',
      docLi29: 'IWS7',
      docLi30: 'ISM50',
      docLi31: 'IWS3',
      docLi32: 'IFC16S',
      docLi33: 'IFC13S',
      docLi34: 'ISM50S',
      docLi35: 'IWS7S',
      docLi36: 'IWS3S',
      config: 'device config appendix',
      softwareSampleCode: 'Sample Code',
      sampleCodeSignature: 'Signature',
      sampleCodePassword: 'Password',
      hardwarePlatform: 'Hardware Platform',
      hardwareModule: 'Modules',
      hardwareAPI: 'API',
      sensorAndController: 'Sensor & Controller',
      http: 'HTTP',
      sdk: 'SDK'
    },
    platformAccess: { // 平台申请开通 与 平台信息修改使用同一份文案
      hardwarePlatform: 'Hardware Platform',
      hardwarePlatformDesc: 'Provide RS485 hardware interface, Modbus RTU communication protocol access to the system.',
      softwarePlatform: 'Software Platform',
      softwarePlatformDesc: 'Provide the interface of HTTPS protocol, which is used to manage and obtain device data.',
      platformOpened: 'Opened',
      platformNotOpen: 'Not Open',
      applicationSteps1: 'Fill in the information',
      applicationSteps2: 'Waiting for review',
      applicationSteps3: 'Verification complete',
      applicationExistError: 'There is information to be approved. Application is not supported.',
      // 资料不完整
      userinfoIncompleteHardwarePlatform: 'hardware platform',
      userinfoIncompleteSoftwarePlatform: 'software platform',
      userinfoIncompletePlatformInfo: 'platform information',
      userinfoIncomplete: 'The current user information is incomplete, ',
      userinfoIncompleteToAdd: 'go to supplement',
      userinfoIncompleteApplyTips1: 'To apply for ',
      userinfoIncompleteApplyTips2: ', you can complete the telephone number、email first.',
      userinfoIncompleteModifyTips1: 'To modify ',
      userinfoIncompleteModifyTips2: ', you can complete the telephone number、email first.',
      // 修改资料
      userinfoModifyBtn: 'Modify',
      // 步骤1，填写资料
      company: 'company',
      companyPlaceholder: 'Input company',
      companyEmptyError: 'Please input company',
      companyFormatError: 'Company name is too long, limit 80 characters',
      region: 'location',
      regionPlaceholder: 'Please select province/city',
      regionEmptyError: 'Please select province/city',
      contacts: 'contacts',
      contactsPlaceholder: 'Please input contacts',
      contactsEmptyError: 'Please input contacts',
      contactsFormatError: 'Do not support numbers and symbols, limit 80 characters',
      applicationReason: 'Description',
      applicationReasonPlaceholder: 'Please input application description',
      applicationReasonEmptyError: 'Please input application description',
      applicationReasonFormatError: 'The content is too long, limit 100 characters',
      backBtn: 'Back',
      submitToAuditBtn: 'Submit for review',
      applicationSubmitSuccess: 'Application submitted successfully',
      applicationSubmitSuccessTips: 'We will audit at the first time, please wait for the result.',
      applicationAuditSuccess: 'Verification successful', // 审核通过
      applicationAuditSuccessToUseBtn: 'Start using',
      applicationAuditFail: 'Verification failed',
      applicationAuditFailReason: 'Failure reason：',
      applicationAuditFailConfirmBtn: 'OK',
      applicationAuditFailReapply: 'Reapply',
      applicationAuditFailReModify: 'Revamp'
    },
    // 基本设置
    softwareSetting: {
      clientId: 'client_id',
      clientIdDesc: 'Add to API request URL parameter.',
      secret: 'secret',
      secretDesc: 'Used to add the signature to the API request URL parameter after generating the signature.',
      url: 'Message Push URL',
      urlDesc: 'It is used to receive the message sent by the device, and push the message to the set URL server when the device sends the message.',
      urlFormatError: 'Please input the correct format of the URL address',
      ipWhiteList: 'IP White List',
      EditBtn: 'Set',
      ipWhiteListDesc1: '1、After whitelist is set, API access server IP will be restricted. If some API interfaces are not set, they will not be accessible.',
      ipWhiteListDesc2: '2、The IP white list will take effect after 1 minute.',
      saveBtn: 'Save',
      subject: 'Subject Reception',
      subjectDesc: '',
      subjectAll: 'Receive all',
      subjectPart: 'Receive only specified subject',
      subjectError: 'Subject error, please check',
      ipWhiteListEditTitle: 'Add white list',
      ipWhiteListEditTips: 'Tips: Support to add {max} IP',
      ipPlaceholder: 'Input IP address',
      ipEmptyError: 'Please input IP address',
      ipFormatError: 'Please input the correct format of IP address',
      ipOverError: 'Support to add {max} whitelists, {total} have been added',
      ipExistError: 'The IP address you input has been added',
      ipAddBtn: 'Add',
      ipWhiteListEmpty: 'No white list',
      ip: 'White List',
      operation: 'Operation',
      deleteBtn: 'delete',
      backBtn: 'Back',
      commitBtn: 'Commit'
    },
    // 示例代码
    sampleCode: {
      copyCode: 'Copy',
      copySuccess: 'Copy succeeded',
      copyFail: 'Copy failed'
    },
    // 实用工具
    tools: {
      signature: 'signature',
      password: 'password',
      passwordTips: '* password is a random string, which is only used to verify the algorithm.',
      getSignatureBtn: 'Generate signature',
      getEncryptedDataBtn: 'Generate encrypted password'
    },
    // 模块列表
    hardwareModule: {
      status: 'Status',
      all: 'All',
      passed: 'Passed',
      auditting: 'Auditting',
      noPassed: 'Rejected',
      addModuleBtn: 'Add',
      // 模块列表内容
      moduleListEmpty: 'No data',
      name: 'Name',
      protocol: 'Protocol',
      model: 'Model',
      content: 'Content',
      viewContentBtn: 'Details',
      operation: 'Operation',
      editBtn: 'Edit',
      releaseBtn: 'Release',
      recallBtn: 'Recall',
      deleteBtn: 'Delete',
      saveBtn: 'Save', // 排序保存按钮
      unsupportedModule: 'This module type is not supported.',
      // 关闭模块详情提示
      closeModuleDetailComfirm: 'The operation has not been saved, are you sure to close it?',
      closeModuleDetailTitle: 'Close',
      closeModuleDetailComfirmEnter: 'Close',
      closeModuleDetailComfirmCancel: 'Cancel',
      // 添加模块
      moduleStep1: 'Module information',
      moduleStep2: 'Module configuration',
      moduleStep3: 'Submit for review',
      // 模块配置字段
      s_addr: 'Slave address',
      s_addrPlacrholder: 'Input the slave address, such as 100. Only integer values of 1 ~ 250 can be input. Do not use the broadcast address',
      s_addrEmptyError: 'Please input the slave address',
      s_addrFormatError: 'Only integer value of 1~250 can be input. Do not use the broadcast address',
      conf_addr: 'Configure address',
      conf_addrPlaceholder: 'Input the configure address, such as 100',
      conf_addrEmptyError: 'Please input the configure address',
      conf_addrFormatError: 'Only can input the integer value of 0~65535',
      baud_rate: 'Baud Rate',
      baud_ratePlaceholder: 'Please choose the baud rate',
      baud_rateEmptyError: 'Please choose the baud rate',
      parity: 'Parity',
      parityPlaceholder: 'Please choose the parity',
      moduleName: 'Module name',
      moduleNamePlaceholder: 'Input the module name, such as "Thermometer"',
      moduleNameEmptyError: 'Please input the module name',
      moduleNameFormatError: 'The length of module name cannot exceed 15 characters',
      moduelModel: 'Module model',
      moduelModelPlaceholder: 'Input the module name, such as "WS1"',
      moduleModelEmptyError: 'Please input the module name',
      moduelModelFormatError: 'The module name is limited to English letters, numbers and underscores_',
      moduelModelFormatErrorLength: 'The module model cannot exceed 15 characters',
      moduelModelExistError: 'The module model input is already exist, please modify the module model',
      backBtn: 'Back',
      nextBtn: 'Next',
      // 返回上层确认
      backToModuleTitle: 'Back',
      backToModuleComfirm: 'Back to the previous step, the current modification data will not be saved. Are you sure you want to return?',
      moduleDataError: 'There are unfilled or unqualified data in the configuration, please check',
      // 具体模块配置
      sensorName: 'Name',
      sensorNamePlaceholder: 'Input the name, such as Sensor1',
      sensorNameEmptyError: 'Please input the name',
      sensorNameFormatError: 'The name cannot exceed 15 characters',
      sensorType: 'Type',
      sensorTypePlaceholder: 'Please select type',
      sensorTypeEmptyError: 'Please select type',
      sensorTypeLimitError: 'Only {max} modules of this type can be added, which has exceeded the limit',
      r_type: 'Register type',
      r_typePlaceholder: 'Please select register type',
      r_typeEmptyError: 'Please select register type',
      d_addr: 'Data address',
      d_addrPlaceholder: 'Input the data address, such as 100',
      d_addrEmptyError: 'Please input the data address',
      d_addrFormatError: 'Only input the integer value of 0~255',
      format: 'Data format',
      formatPlaceholder: 'Please select data format',
      formatEmptyError: 'Please select data format',
      formula: 'Data formula',
      formulaPlaceholder: 'Please select data formula',
      formulaEmptyError: 'Please select data formula',
      validRange: 'Effective interval',
      validRangeEmptyError: 'Please input the data address',
      validRangeFormatError: 'Please input integer value',
      validRangeOverRangeError: 'Only input ',
      minBiggerThanMaxError: 'The minimum value input is greater than the maximum value',
      minPlaceholder: 'Minimum value',
      maxSmallerThanMinError: 'The maximum value input is less than the minimum value',
      maxPlaceholder: 'Maximum value',
      unit: 'Unit',
      unitEmptyPlaceholder: 'None',
      unitPlaceholder: 'Please select data unit',
      map: 'Mapping table',
      mapEmpty: 'None',
      code: 'Status Code',
      codePlaceholder: 'Status Code{index}',
      validCodeRangeError: 'Please input in the effective interval of the module first',
      validCodeFormatError: 'The status code can only be input in the legal integer value within the effective interval',
      validCodeRepeatError: 'Duplicate status codes exist in the mapping table, please check',
      desc: 'Desc',
      descPlaceholder: 'Desc',
      validDescFormatError: 'Description is limited to 30 characters',
      validDescEmptyError: 'There is no corresponding status code description in the mapping table, please check',
      preBtn: 'Back',
      moduleApplyBtn: 'Add',
      moduleEditBtn: 'Edit',
      // 模块添加成功
      applicationSubmitSuccess: 'Module submitted successfully',
      applicationSubmitSuccessTips: 'We will audit at the first time, please wait for the result.',
      viewModuleListBtn: 'View module list',
      addModuleMoreBtn: 'Continue to add',
      // 编辑/删除/发布/撤回模块
      editModuleTitle: 'Edit module',
      editModuleConfirm: 'Confirm to edit the module, will recall the module in the module list options.',
      deleteModuleTitle: 'Delete module',
      deleteModuleConfirm: 'Are you sure to delete this module?',
      deleteReleasedModuleConfirm: 'Confirm to delete the module, the user will not be able to get this module in the module list options.',
      releaseModuleTitle: 'Release module',
      releaseModuleConfirm: 'After the release, the module information will be open to the public through the hardware platform.',
      recallModuleTitle: 'Recall module',
      recallModuleConfirm: 'Confirm to recall the module, the user will not be able to get this module in the module list options.',
      confirmEnter: 'Confirm',
      confirmCancel: 'Cancel'
    }
  },
  // 接口请求
  request: {
    401: 'Not logged in',
    411: 'Sign in status expired',
    // 账号登陆
    login: {
      200: 'Sign in successful',
      0: 'Sign in failed, account or password error',
      40002: 'Sign in failed,, account or password error',
      40003: 'Sign in failed, too much numbers of password errors, please try again later'
    },
    // 手机+验证码登录
    telLogin: {
      200: 'Sign in successful',
      0: 'Sign in failed, telephone or verification code error',
      40002: 'Sign in failed'
    },
    // 用户名校验
    checkAccount: {
      200: '', // 校验通过，可以使用
      0: 'The account is already in use, please input another one',
      40005: 'The account is already in use, please input another one'
    },
    // 邮箱校验
    checkEmail: {
      200: '', // 校验通过，可以使用
      0: 'The email is already in use, please input another one',
      40305: 'The email is already in use, please input another one'
    },
    // 注册账号前的邮箱验证
    signupPre: {
      200: 'Verification code sent successfully',
      0: 'Verification code sent failed',
      40004: 'Verification code sent failed, account format error',
      40201: 'Verification code sent failed, email format error',
      40305: 'Verification code sent failed, the email is already in use',
      40005: 'Verification code sent failed, account is already in use',
      40006: 'Verification code sent failed, password format error'
    },
    // 注册账号
    signup: {
      200: 'Account registration succeeded',
      0: 'Account registration failed',
      40000: 'Account registration failed',
      40004: 'Account registration failed，account format error',
      40005: 'Account registration failed，account is already in use',
      40006: 'Account registration failed，password format error',
      40021: 'Account registration failed，verification code is wrong or invalid',
      40201: 'Account registration failed，email format error',
      40305: 'Account registration failed，the email is already in use',
      40307: 'Account registration failed，verification code is wrong or invalid'
    },
    // 注销账号
    deleteAccount: {
      200: 'Account deleted successfully',
      0: 'Account deletion failed, please try again.'
    },
    // 忘记密码 重置前的发送验证码
    forgotPasswordSendValidcode: {
      200: 'Verification code sent successfully',
      0: 'Verification code sent failed',
      40001: 'Verification code sent failed, the account input does not exist',
      40301: 'Verification code sent failed, user does not set the telephone or email',
      40302: 'Verification code sent failed, user does not set the telephone or email',
      40303: 'Verification code sent failed, user does not set the telephone or email'
    },
    // 对验证码的校验
    forgotPasswordVerify: {
      200: 'Verified successfully',
      0: 'Verified failed',
      40021: 'The verification code is wrong or invalid, please get it again',
      40022: 'The verification code is wrong or invalid, please get it again'
    },
    // 重置密码
    resetPassword: {
      200: 'Password reset successful',
      0: 'Password reset failed',
      40021: 'Password reset failed, the verification code is wrong or invalid, please get it again',
      40022: 'Password reset failed, the voucher is invalid, please get it again.',
      40401: 'Password reset failed, password unchanged.'
    },
    // 获取帖子列表 / 动态列表
    getPost: {
      200: 'Data request successful',
      0: 'Data request failed'
    },
    // 删除帖子 / 删除动态 / 删除评论 / 删除回复
    deletePost: {
      200: 'Delete successfully',
      0: 'Delete failed'
    },
    // 搜索帖子列表
    searchPost: {
      200: 'Data search successful',
      0: 'Data search failed'
    },
    // 发布帖子
    newPost: {
      200: 'Post published successfully',
      0: 'Post published failed, please check whether the content contains facial expression characters and other unsupported characters.'
    },
    // 编辑帖子
    editPost: {
      200: 'Post edit successfully',
      0: 'Post edit failed, please check whether the content contains facial expression characters and other unsupported characters.'
    },
    // 获取帖子详情
    getPostDetail: {
      200: 'Post request successful',
      0: 'Post request failed, the post may have been deleted.'
    },
    // 发布对帖子的评论
    newComment: {
      200: 'Comments published successfully',
      0: 'Comments published failed, please check whether the content contains facial expression characters and other unsupported characters.'
    },
    // 发布对评论的回复
    newReply: {
      200: 'Reply published successfully',
      0: 'Reply published failed，please check whether the content contains facial expression characters and other unsupported characters.'
    },
    // 修改昵称
    editNickname: {
      200: 'Nickname set successfully',
      0: 'Nickname set failed',
      40311: 'Nickname set failed, nickname format error'
    },
    // 设置修改密码前身份验证
    editPasswordVerify: {
      200: 'Verified successfully',
      0: 'Verification failed ',
      40002: 'Verification failed. Password is wrong',
      40003: 'Verification failed. The number of password errors is too many. Please try again later'
    },
    // 设置/修改密码
    editPassword: {
      200: 'Password modified successfully',
      0: 'Password modified failed',
      40021: 'Password modified failed, verification code error or has expired',
      40401: 'Password modified failed, password unchanged'
    },
    // 发送验证邮件到邮箱
    sendEmail: {
      200: 'Email sent successfully',
      0: 'Email sent failed',
      40201: 'Email sent failed, email format error',
      40305: 'Email sent failed, the email is already in use'
    },
    // 发送手机验证码
    sendVcode: {
      200: 'Telephone verification code sent successfully',
      0: 'Telephone verification code sent failed'
    },
    // 验证原邮箱
    verifyEmail: {
      200: 'Email verification successful',
      0: 'Email verification failed',
      40021: 'Email verification failed, verification code error',
      40201: 'Email format error',
      40307: 'Email verification timeout',
      40308: 'Email and account do not match'
    },
    // 验证原手机
    verifyTel: {
      200: 'Telephone verification successful',
      0: 'Telephone verification failed',
      40021: 'Telephone verification failed, verification code error',
      40022: 'Telephone verification failed, verification code has expired'
    },
    // 轮询 验证原微信
    verifyWechat: {
      200: 'Wechat verification successful',
      0: 'Wechat verification failed, please use the currently bound wechat-account scan code to verify'
    },
    // 修改用户绑定的邮箱（包括新增 及 修改）
    editEmail: {
      200: 'Email set successfully',
      0: 'Email set failed',
      40021: 'Email set failed, verification code error',
      40201: 'Email set failed, email format error',
      40305: 'Email set failed, the email is already in use',
      40307: 'Email set failed, the link is invalid, please apply again',
      40308: 'Email set failed, the email and current account do not match',
      40309: 'Email set failed, the current account has been bound to this email'
    },
    // 修改联系方式 （包括新增 及 修改）
    editTel: {
      200: 'Telephone set successfully',
      0: 'Telephone set failed',
      40021: 'Telephone set failed, verification code error',
      40022: 'Telephone set failed, verification code has expired',
      40023: 'Telephone set failed, the telephone is already in use',
      40025: 'Telephone set failed, the telephone is the same as the original one'
    },
    // 修改微信 （包括新增 及 修改）
    editWechat: {
      200: 'Wechat set successfully',
      0: 'Wechat set failed',
      40310: 'Wechat set failed, the wechat has been bound to this account',
      40306: 'Wechat set failed, the wechat has been bound by other accounts'
    },
    // 解除绑联系方式, 邮箱,微信
    deleteInfo: {
      200: 'Unbind succeeded',
      0: 'Unbind failed',
      40021: 'Unbind failed, verification code error',
      40022: 'Unbind failed, verification code has expired'
    },
    // 验证输入的授权账号
    checkSubAccount: {
      200: '',
      1: 'The input account has been added',
      0: 'The input account cannot be added',
      40001: 'The input account does not exist',
      40004: 'The input account format error',
      40016: 'The input account does not have API permission',
      40017: 'The input account is not a common user type',
      40304: 'The input account is not registered by email',
      40601: 'The input account cannot be the same as the current account',
      40602: 'The number of authorized accounts added exceeds the limit'
    },
    // 添加授权账号
    addSubAccount: {
      200: 'Authorized account added successfully',
      0: 'Failed to add authorized account',
      40001: 'Failed to add authorized account, the account input does not exist',
      40004: 'Failed to add authorized account, the account input format error',
      40016: 'Failed to add authorized account, the account input does not have API permission',
      40017: 'Failed to add authorized account, the account input is not a common user type',
      40304: 'Failed to add authorized account, the account input is not registered by email',
      40601: 'Failed to add authorized account, the account input cannot be the same as the current account',
      40602: 'Failed to add authorized account, the number of authorized accounts added exceeds the limit'
    },
    // 删除授权账号
    deleteSubAccount: {
      200: 'Authorized account deleted successfully',
      0: 'Failed to delete authorized account'
    },
    // 获取已授权设备列表
    getAuthedDevices: {
      200: 'Get authorized device list successfully',
      0: 'Failed to get authorized device list'
    },
    // 获取可授权设备列表
    getUnAuthedDevices: {
      200: 'Get device list can be authorized successfully',
      0: 'Failed to get authorized device list'
    },
    // 添加授权设备
    addAuthedDevices: {
      200: 'Authorize device successfully',
      0: 'Fail to authorize device'
    },
    // 更新授权设备权限
    updateAuth: {
      200: 'Updated Authorized device successfully',
      0: 'Fail to updated Authorized device'
    },
    // 提交申请 审核
    newApply: {
      200: 'Submit audit successfully',
      0: 'Fail to submit audit',
      41000: 'Fail to submit audit, aduit is already exist, please do not submit again.',
      41001: 'Fail to submit audit, company infomation is empty',
      41002: 'Fail to submit audit, region infomation is empty',
      41003: 'Fail to submit audit, contacts is empty',
      41010: 'Fail to submit audit, reasons for application is too long',
      40302: 'Fail to submit audit, telephone is empty '
    },
    comfrimApply: {
      200: 'Confirm audit successfully',
      0: 'Fail to confirm audit'
    },
    // 更新 开发者设置
    editDevConfig: {
      200: 'Set successfully',
      0: 'Fail to set'
    },
    // 校验模块型号
    checkModel: {
      200: '',
      0: 'The module model is already exist, please modify the module model'
    },
    // 获取模块列表
    getModuleList: {
      200: 'Get module list successfully',
      0: 'Fail to get module list'
    },
    // 发布模块
    releaseModule: {
      200: 'Release The module successfully',
      0: 'Fail to release the module',
      42002: 'Fail to release the module, the current user does not have hardware API permission',
      42003: 'Fail to release the module, the status of the module has no change',
      42004: 'Fail to release the module, the module did not pass the audit'
    },
    // 撤回模块
    recallModule: {
      200: 'Recall the module successfully',
      0: 'Fail to recall the module',
      42002: 'Fail to recall the module, the current user does not have hardware API permission',
      42003: 'Fail to recall the module, the status of the module has no change',
      42004: 'Fail to recall the module, the module did not release'
    },
    // 添加模块 / 编辑模块
    addModule: {
      200: 'Module submitted successfully',
      0: 'Failed to submit module',
      42000: 'Failed to submit module, the module model is already exist, please modify the module model'
    },
    // 删除模块
    deleteModule: {
      200: 'Module deleted successfully',
      0: 'Failed to delete module'
    },
    // 模块排序保存
    rankModule: {
      200: 'Module saved successfully',
      0: 'Failed to save module'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js